<template>
    <CookieBannerMobile />
    <div class="mian">
        <!-- 顶部栏 -->
        <header @click="handleHeaderClick">
            <div class="header_leftbox">
                <img class="header_LOGO" src='@/assets/logo3备份@2x.png' @click="selectedclick('Home')" />
                <img class="header_Searchicon" src="@/assets/Homeimg/menu-2-fill@2x.webp" alt=""
                    @click="() => { showSearch = '0px'; }" />
            </div>
            <div class="header_rightbox">
                <template v-for="(item, index) in usericonarr" :key="item">
                    <div class="header_icon" @click="open(index)">
                        <first_icon :icon_name="item.unurl" />
                    </div>
                </template>
            </div>
        </header>
        <!-- 搜索界面 -->
        <div class="Search_masker" v-loading="sreacloading">
            <div class="Search_top">
                <div class="Search_top_left">
                    <div class="Search_btn">
                        <img class="header_Searchicon" src="@/assets/Homeimg/Icon Search@2x.webp" alt="" />
                    </div>
                    <input class="Search_input" type="search" placeholder="Search" @input="getSeachWord_de($event)"
                        @keydown.enter="search_input($event)" />
                    <!-- @change="search_input($event)" -->
                </div>
                <div class="Search_top_rghit" @click="() => {
                    showSearch = '-100%';
                }">
                    <img class="back_icon" src="@/assets/Homeimg/gobackicon.webp" alt="" />
                </div>
            </div>
            <!-- 类型列表 -->
            <div class="Search_masker_mian" v-if="!sreactblen">
                <div class="classifyone">
                    <div class="topbox">
                        <template v-for="(item, index) in Sidebararr" :key="item">
                            <div class="classifyone_item" :style="{ background: item.bg }"
                                @click="selectedclick(item.title)" v-if="index < 2">
                                <div class='classifyone_icon' :src="item.selected_icon">
                                    <first_icon :icon_name="item.unchecked_icon" />
                                </div>
                                <div class='classifyone_name'>
                                    {{ item.name }}
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="bottombox">
                        <template v-for="(item, index) in Sidebararr" :key="item">
                            <div class="classifyone_item" :style="{ background: item.bg }"
                                @click="selectedclick(item.title)" v-if="index > 1">
                                <div class='classifyone_icon' :src="item.selected_icon">
                                    <first_icon :icon_name="item.unchecked_icon" />
                                </div>
                                <div class='classifyone_name'>
                                    {{ item.name }}
                                </div>
                            </div>
                        </template>
                    </div>

                </div>
                <div class="classifytwo">
                    <div class="classifytwo_item" v-for="(item, index) in categories_list" :key="item"
                        @click="selectedclick(item)">
                        <img class="classifytwo_icon" :src="item.ico" />
                        <div class="bottom_text"> {{ item.name }}</div>
                    </div>
                </div>
                <div class="i18nchange">
                    <el-select popper-class="mySelectStyle" v-model="i18nvalue" placeholder="English"
                        @change="changeLang" size="large" teleported="false">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>

                <div class='about_list'>
                    <template v-for="(item, index) in aboutlistarr" :key="item">
                        <!-- <div @click="aboutlist_item_click(index)" class="about_list_item">
                            {{ item }}
                        </div> -->

                        <div @click="aboutlist_item_click(index)" class="about_list_item">
                            <a href="/privacy_policy.html" target='_blank' v-if="index == '3'">
                                {{ item }}
                            </a>
                            <a href="https://about.iglees.com" target='_blank' v-else-if="index == '0'">
                                {{ item }}
                            </a>
                            <a href="/terms_of_service.html" target='_blank' v-else-if="index == '4'">{{ item }}
                            </a>
                            <text v-else>{{ item }} </text>
                        </div>
                    </template>
                </div>
                <div class="right_list_thirdparty">
                    <div class="icon_box">
                        <template v-for="(item, index) in thirdpartyarr" :key="item">
                            <div class="icon_img" @click="thirdparty_click(index)">

                                <first_icon :icon_name="item.url" />
                            </div>
                        </template>
                    </div>
                </div>

            </div>
            <!-- 搜索返回列表 -->
            <div class="Search_masker_mian" v-else>
                <Nothingbox v-if="nothingboxblen" />
                <Loading_mb v-if="loadingblen" />
                <template v-for="(item, index) in keywordarr" :key="item">
                    <div class="Search_list_item" @click="go_details(item)">
                        <img class="Search_img" :src="item.image" alt="">
                        {{ item.name }}
                    </div>
                </template>

            </div>

        </div>
        <!-- 内容区域 -->
        <div class="Content_area" ref="outerDom">
            <!-- 路由出口  sectionRef-->
            <router-view @feedback="Feedbackon" @gdlogin="Gdloginon" :useloginblen="useloginblen" />
        </div>
        <div class="backtopbox" @click="backTop" v-show="btnblock">
            <div class="icon_box">
                <img src="@/assets/Homeimg/jiantou@2x.png" alt="" />
            </div>
        </div>
        <el-drawer v-model="drawer2" destroy-on-close="true" :show-close="false" direction="rtl" @close="closedarw(1)">
            <div class="drawer_conent" v-if="drawer2" v-loading="useloading">
                <div class="Friends_conent" v-if="openindex == '0'">
                    <first_header title="Friends" @getValue="getValue">
                        <template #title>
                            <span>{{ $t("navigateBar.friends") }}</span>
                        </template>
                    </first_header>
                    <div class="friends_box" v-if="useloginblen">
                        <div class="friends_list" v-if="Optionsindex == '0'">
                            <div class="top">
                                <div class="friends_search">
                                    <input type="text" :placeholder="t('FindFrieds')"
                                        @input="inputclick($event, friend_search)" @keydown.enter="friend_search()" />
                                    <div class="sreach_icon">
                                        <img src="@/assets/Homeimg/Icon Search@2x.webp" alt=""
                                            @click="friend_search()" />
                                    </div>
                                </div>
                            </div>
                            <div class="friends_list_item" v-if="friendsarr?.length > 0">
                                <template v-for="(item, index) in friendsarr" :key="item">
                                    <friends_card :friendvalue="item" @handleAdd="handleAdd" :index="Optionsindex"
                                        @dechouti="dechouti" />
                                </template>
                            </div>
                            <div class="friends_not" v-if="friendsarr?.length == 0">
                                <div class="kongbai">
                                    <img src="@/assets/Homeimg/ziyuan1@3x.png" alt="" />
                                </div>
                                <div class="kongbai_text">
                                    {{ $t("navigateBar.Invitte_your_friends") }}
                                </div>
                                <div class="bottomtext_text">
                                    <p>
                                        {{
                                            $t("navigateBar.FindFriendsbySearchiingForTheirUsemames")
                                        }}
                                    </p>
                                    <p @click="Options_click(3)">
                                        <!-- {{ $t("navigateBar.or") }} -->
                                        <text style="color: #00ffe0">{{ $t("navigateBar.ShareyourQrcodeinviteLink") }}
                                        </text>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="Friend_requests" v-if="Optionsindex == '1'">
                            <div class="Friend_requests_title">
                                {{ t("ReceivedRequest") }}
                            </div>
                            <div class="friends_list_item" v-if="friendgetarr?.length <= 0">
                                <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                                <div class="bottomtext_text">
                                    {{ t("Notyet") }}
                                </div>
                            </div>
                            <div class="friends_list_item" v-if="friendgetarr?.length > 0">
                                <template v-for="(item, index) in friendgetarr" :key="item">
                                    <friends_card :friendvalue="item" @handleAdd="handleAdd" :index="Optionsindex"
                                        @dechouti="dechouti" />
                                </template>
                            </div>
                        </div>
                        <div class="Friend_application" v-if="Optionsindex == '2'">
                            <div class="Friend_application_title">{{ t("SentRequest") }}</div>
                            <div class="friends_list_item" v-if="friendsetarr?.length <= 0">
                                <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                                <div class="bottomtext_text">
                                    {{ t("Notyet") }}
                                </div>
                            </div>

                            <div class="friends_list_item" v-if="friendsetarr?.length > 0">
                                <template v-for="(item, index) in friendsetarr" :key="item">
                                    <friends_card :friendvalue="item" @handleAdd="handleAdd" :index="Optionsindex"
                                        @dechouti="dechouti" />
                                </template>
                            </div>
                        </div>
                        <div class="Friend_Mine" v-if="Optionsindex == '3'">
                            <div class="Friend_Mine_title">
                                <p>
                                    {{ $t("showqr") }}
                                </p>
                                {{ $t("sendyoufdre") }}
                            </div>
                            <div class="Friend_qr">
                                <!-- <img src="../../../assets/Homeimg/二维码.webp" alt="" /> -->
                                <vue-qr :text="1111" :size="280" :callback="getImgInfo"></vue-qr>
                            </div>
                            <div class="Friend_Share" @click="Friend_Share">
                                <div class="Share_icon">
                                    <img src="@/assets/Homeimg/fenxiang1.webp" alt="" />
                                </div>
                                {{ $t("Shareyourprofile") }}
                            </div>
                            <div class="Friend_Copy" @click="Friend_Copy">
                                <div class="Share_icon">
                                    <img src="@/assets/Homeimg/lujing@2x.png" alt="" />
                                </div>
                                {{ $t("CopyInviteLink") }}
                            </div>
                        </div>
                    </div>
                    <div class="friends_box" v-if="!useloginblen">
                        <div class="loginnull">
                            <img class="imgon" src="@/assets/Homeimg/ziyuan1@3x.png" alt="" />
                            <div class="kongbai_text">
                                {{ $t("navigateBar.Bring_your_friends") }}
                            </div>
                            <div class="bottomtext_text">
                                <p>{{ $t("navigateBar.Create_a_CrazyGames") }}</p>
                                <p>
                                    <text style="color: #00ffe0">
                                        {{ $t("navigateBar.start_inviting_your_friends") }}
                                    </text>
                                </p>
                            </div>

                            <div class="gologinbtn" @click="gotologin()">
                                {{ $t("navigateBar.Login") }} / {{ $t("navigateBar.Register") }}
                            </div>
                        </div>
                    </div>
                    <div class="friends_list_Options" v-if="useloginblen">
                        <template v-for="(item, index) in oparr" :key="item">
                            <div class="Options_tab" :class="Optionsindex == index ? 'selected_tab' : ''"
                                @click="Options_click(index)">
                                {{ item }}
                            </div>
                        </template>
                    </div>
                </div>
                <div class="Favorites_conent" v-if="openindex == '1'">
                    <!-- 收藏游戏列表 -->
                    <first_header title="Favorites" @getValue="getValue">
                        <!-- favorites -->
                        <template #title>
                            <span>{{ $t("navigateBar.favorites") }}</span>
                        </template>
                    </first_header>
                    <!-- <div v-if="useloginblen"> -->
                    <div class="Favorites_top">
                        <div class="Favorites_search">
                            <input type="text" :placeholder="t('Searchbygame')" @input="inputclick($event, collect_de)"
                                @keydown.enter="collect_de()" />
                            <div class="sreach_icon">
                                <img src="@/assets/Homeimg/Icon Search@2x.webp" alt="" @click="collect_de()" />
                            </div>
                        </div>
                        <!-- 时间范围筛选 -->
                        <!-- <div class="timeselect">

                            <el-config-provider :locale="ellocale">
                                <el-date-picker v-model="timefb" popper-class="date-style" type="datetimerange"
                                    range-separator="|" :start-placeholder="timefbtext.start"
                                    :end-placeholder="timefbtext.end" @change="collect_de" format="YYYY-MM-DD"
                                    value-format="YYYY-MM-DD" />
                            </el-config-provider>

                        </div> -->



                    </div>

                    <div class="Favorites_box">
                        <div class="friends_list_item" v-if="Favoritesarr?.length <= 0">
                            <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                            <div class="bottomtext_text">
                                {{ t("Notyet") }}
                            </div>
                        </div>
                        <div v-for="(val, key) in Favoritesarr" :key="key" v-else>
                            <div class="Favorites_list_item">
                                <div class="Favorites_list_title">{{ key }}</div>
                                <div class="Favorites_cardconent">
                                    <template v-for="(item1, index1) in Favoritesarr[key]" :key="item1">
                                        <div class="Favorites_card">
                                            <Favoritescard :videourl="item1?.video" :imgurl="item1?.image"
                                                :gamename="item1?.name" :id="item1.id" :icon="item1.ico"
                                                :showtap="showtap" @selecttap="selecttap" :checkedblen="checkedblen"
                                                @click="Ftclick(item1)" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Favorites_right">
                        <div class="Favorites_Delete Favorites_btn" :class="showtap ? 'tranbtnone' : ''"
                            @click="delFavorite_de()">
                            {{ $t("Delete") }}
                        </div>
                        <div class="Favorites_Manage Favorites_btn" :class="showtap ? 'tranbtn' : ''"
                            @click="start_manage()">
                            {{ showtap ? $t("navigateBar.Cancel") : $t("Manage") }}
                        </div>
                    </div>

                </div>
                <div class="User_Center" v-if="openindex == '3'">
                    <div class="user_one" v-if="user_state == '1'">
                        <first_header title="User Center" @getValue="getValue">
                            <template #title>
                                <span>{{ $t("navigateBar.user_center") }}</span>
                            </template>
                        </first_header>
                        <div class="User_title">
                            <div class="User_title_left">
                                <div class="User_icon">
                                    <img :src="usedata.avatar ? usedata.avatar : usefromdata.avatar" alt=""
                                        v-if="!useChage && usefromdata.avatar" />
                                    <img src="@/assets/Homeimg/deuserimg.jpg" alt=""
                                        v-if="!useChage && !usefromdata.avatar" />
                                    <!-- ../../../assets/Homeimg/deuserimg.jpg -->
                                    <label for="peas112">
                                        <div class="icon" v-if="useChage">
                                            <img v-if="usedata.avatar" :src="usedata.avatar" alt="" />
                                            <img v-else src="@/assets/Homeimg/deuserimg.jpg" alt="" />
                                            <div class="iconmask">
                                                <img src="@/assets/Homeimg/xiugaixinxi@2x.webp" />
                                            </div>
                                        </div>
                                    </label>
                                    <input type="file" id="peas112" style="display: none" @change="uploudmian"
                                        data-type="shareimg" />
                                </div>
                                <div class="User_right">
                                    <div class="User_name">
                                        <div class="Chagebox" v-if="useChage">
                                            <input v-model="usedata.nickname" ref="inputRef"
                                                :placeholder="usefromdata.nickname" />
                                            <div class="usecompletebox" @click="handleCommand('1')">
                                                {{ t("usecomplete") }}
                                            </div>
                                        </div>
                                        <div v-if="!useChage" class="Chageboxone">
                                            {{ usefromdata.nickname }}
                                        </div>
                                        <img src="@/assets/Homeimg/xiugaixinxi@2x.webp" @click="handleCommand('2')"
                                            v-if="!useChage" />
                                    </div>
                                    <div class="User_eamil">{{ usefromdata.email }}</div>
                                </div>
                            </div>
                            <div class="User_title_right" @click="gotowallet">
                                {{ $t(`navigateBar.My_wallet`) }}
                            </div>
                        </div>
                        <div class="User_Information">
                            <template v-for="(item, key, i) in usefromdata.info" :key="item">
                                <div class="User_Information_item">
                                    <div class="text_one">{{ item }}</div>
                                    <div class="text_two">{{ $t(`navigateBar.mob_${key}`) }}</div>
                                    <!-- <div class="text_two">{{ key }}</div> -->
                                </div>
                            </template>
                        </div>
                        <div class="User_outing_history">
                            <div class="User_outing_card">
                                <div class="User_outing_card_title">
                                    <div class="title_left">
                                        {{ $t(`navigateBar.Recently_Played`) }}
                                    </div>
                                    <div class="title_right" @click="more_click(1)">{{ $t(`navigateBar.view_more`) }}
                                    </div>
                                </div>

                                <div class="User_outing_list_not" v-if="usefromdata.RecentlyPlayedList.length <= 0">
                                    <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                                    <div class="bottomtext">
                                        {{ t("Notyet") }}
                                    </div>
                                </div>
                                <div class="User_outing_list" v-else>
                                    <template v-for="item in usefromdata.RecentlyPlayedList" :key="item">
                                        <div class="User_outing_list_item">
                                            <Card_meta :Cardcontents="item" @click="Userclick(item)" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="User_outing_card">
                                <div class="User_outing_card_title">
                                    <div class="title_left">
                                        {{ $t(`navigateBar.Favorites`) }}
                                    </div>
                                    <div class="title_right" @click="more_click(2)">{{ $t(`navigateBar.view_more`) }}
                                    </div>
                                </div>

                                <div class="User_outing_list_not" v-if="usefromdata.FavoritesList.length <= 0">
                                    <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />

                                    <div class="bottomtext">
                                        {{ t("Notyet") }}
                                    </div>
                                </div>
                                <div class="User_outing_list" v-else>
                                    <template v-for="item in usefromdata.FavoritesList" :key="item">
                                        <div class="User_outing_list_item">
                                            <Card_meta :Cardcontents="item" @click="Userclick(item)" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="User_bottom_btn">
                            <div class="login_out btn" @click="uselogout_de()">
                                {{ $t(`navigateBar.LogOut`) }}
                            </div>
                            <div class="dle_btn btn" @click="zhuxiao">
                                {{ $t(`navigateBar.Del_Accout`) }}
                            </div>
                        </div>
                    </div>
                    <div class="user_login" v-if="user_state == '2'">
                        <first_header title="Login" @getValue="getValue">
                            <template #title>
                                <span>{{ $t("navigateBar.Login") }}</span>
                            </template>
                        </first_header>
                        <!-- <div class="user_login_title">{{ $t(`navigateBar.tpal`) }}</div> -->
                        <!-- 谷歌登录 -->

                        <div class="user_login_googlebtn">
                            <!-- <div id="appleid-signin" data-color="black" data-border="true" data-type="sign in"></div> -->
                        </div>
                        <div class="user_login_googlebtn">
                            <!-- <div class='googlebtn'>
                <img class="googlebtn_icon" src="../../../assets/Homeimg/639846264527386643@2x.webp" alt="" />
                Continue With Google
              </div> -->
                            <component :is="'script'" src="https://accounts.google.com/gsi/client" ansyc />
                            <div id="g_id_onload"
                                data-client_id="865824439772-iqm8o5bnrstsceidhph861i65vpg5he5.apps.googleusercontent.com"
                                data-context="signin" data-ux_mode="popup" data-callback="googleSignCallBack"
                                data-auto_prompt="false">
                            </div>

                            <div class="g_id_signin" data-type="standard" data-shape="pill" data-theme="outline"
                                data-text="signin_with" data-size="large" data-logo_alignment="center" data-width="300">
                            </div>
                        </div>
                        <div class="Accout_login_title">
                            <div class="leftone"></div>
                            or
                            <div class="rightone"></div>
                        </div>
                        <el-form class="Accout_login_Form" :model="ruleForm" ref="ruleFormRef" :rules="loginRules"
                            validate-on-rule-change>
                            <!-- ///////////////// -->
                            <div class="Accout_login_item1">
                                <el-form-item prop="email">
                                    <el-input input-style="inpuone" type="text" :placeholder="t('pladdemail')"
                                        autocomplete="off" class="Accout_login_input" v-model="ruleForm.email">
                                        <template #prefix>
                                            <img class="Accout_login_icon" src="@/assets/Homeimg/lujing@2x (2).webp"
                                                alt="" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <!-- <div class="validatetext">122</div> v-model="ruleForm.email" -->
                            </div>
                            <!-- //////////////////////// -->
                            <div class="Accout_login_item2">
                                <el-form-item prop="password">
                                    <el-input type="password" :placeholder="t('plpassword')" autocomplete="off"
                                        class="Accout_login_input" v-model="ruleForm.password" show-password>
                                        <template #prefix>
                                            <img class="Accout_login_icon" src="@/assets/Homeimg/lujing@2x (1).webp"
                                                alt="" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <!-- ////////////////////////////////////////-->
                            <div class="Accout_operation">
                                <div class="left_box" @click="user_handoff('3')">
                                    {{ $t(`navigateBar.newuser`)
                                    }}<text> {{ $t(`navigateBar.Register`) }}</text>
                                </div>
                                <div class="rigt_box" @click="user_handoff('4')">
                                    {{ $t(`navigateBar.Forget_Password`) }}
                                </div>
                            </div>
                            <div class="Accout_loginbtn" @click="uselogin(ruleFormRef)">
                                {{ $t(`navigateBar.Login`) }}
                            </div>
                        </el-form>
                    </div>
                    <div class="user_register" v-if="user_state == '3'">
                        <first_headerback title="Register" @getValue="getValue" @user_handoff="user_handoff">
                            <template #title>
                                <span>{{ $t("navigateBar.Register") }}</span>
                            </template>
                        </first_headerback>
                        <el-form class="user_register_Form" :model="ruleForm" ref="ruleFormR_re" :rules="loginRules"
                            validate-on-rule-change>
                            <div class="user_register_item1">
                                <el-form-item prop="email">
                                    <el-input type="text" :placeholder="t('pladdemail')" autocomplete="off"
                                        class="Accout_login_input" v-model="ruleForm.email">
                                        <template #prefix>
                                            <img class="user_register_icon" src="@/assets/Homeimg/lujing@2x (2).webp"
                                                alt="" />
                                        </template>
                                        <template #suffix>
                                            <div class="user_register_send" @click="
                                                remainingTime > 0 ? '' : get_email_code('register')
                                                ">
                                                <div v-if="remainingTime == 0">{{ btntext }}</div>
                                                <div v-if="remainingTime > 0">{{ timetext }}</div>
                                            </div>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="user_register_item2">
                                <el-form-item prop="captcha">
                                    <el-input type="text" :placeholder="t('plemailcode')" autocomplete="off"
                                        class="Accout_login_input" v-model="ruleForm.captcha">
                                        <template #prefix>
                                            <img class="user_register_icon" src="@/assets/Homeimg/lujing@2x.webp"
                                                alt="" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="user_register_item2">
                                <el-form-item prop="password">
                                    <el-input type="password" :placeholder="t('plpassword')" autocomplete="off"
                                        class="Accout_login_input" v-model="ruleForm.password" show-password>
                                        <template #prefix>
                                            <img class="user_register_icon" src="@/assets/Homeimg/lujing@2x (1).webp"
                                                alt="" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="user_register_operation">
                                <div class="left_box" @click="user_handoff('2')">
                                    {{ $t("navigateBar.Hasaccount")
                                    }}<text> {{ $t("navigateBar.Login") }} </text>
                                </div>
                            </div>
                            <el-form-item prop="setype">
                                <div class="user_register_check">
                                    <el-checkbox-group v-model="ruleForm.setype">
                                        <el-checkbox value="1" name="setype"> </el-checkbox>
                                    </el-checkbox-group>
                                    <div class="textbox" v-html="$t('navigateBar.iam13')"></div>
                                </div>
                            </el-form-item>
                            <div class="user_register_loginbtn" @click="retap(ruleFormR_re)">
                                {{ $t("navigateBar.Register") }}
                            </div>
                        </el-form>
                    </div>
                    <div class="user_register" v-if="user_state == '4'">
                        <first_headerback title="Forget Password" @getValue="getValue" @user_handoff="user_handoff">
                            <template #title>
                                <span>{{ $t("navigateBar.Forget_Password") }}</span>
                            </template>
                        </first_headerback>
                        <el-form class="user_register_Form" :model="ruleForm" ref="ruleFormR_pwd" :rules="loginRules"
                            validate-on-rule-change>
                            <div class="user_register_item1">
                                <el-form-item prop="email">
                                    <el-input type="text" :placeholder="t('pladdemail')" autocomplete="off"
                                        class="Accout_login_input" v-model="ruleForm.email">
                                        <template #prefix>
                                            <img class="user_register_icon" src="@/assets/Homeimg/lujing@2x (2).webp"
                                                alt="" />
                                        </template>
                                        <template #suffix>
                                            <div class="user_register_send" @click="
                                                remainingTime > 0 ? '' : get_email_code('resetpwd')">
                                                <div v-if="remainingTime == 0">{{ btntext }}</div>
                                                <div v-if="remainingTime > 0">{{ timetext }}</div>
                                            </div>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="user_register_item2">
                                <el-form-item prop="captcha">
                                    <el-input type="text" :placeholder="t('plemailcode')" autocomplete="off"
                                        class="Accout_login_input" v-model="ruleForm.captcha">
                                        <template #prefix>
                                            <img class="user_register_icon" src="@/assets/Homeimg/lujing@2x.webp"
                                                alt="" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="user_register_item2">
                                <el-form-item prop="password">
                                    <el-input type="password" :placeholder="t('plpassword')" autocomplete="off"
                                        class="Accout_login_input" v-model="ruleForm.password" show-password>
                                        <template #prefix>
                                            <img class="user_register_icon" src="@/assets/Homeimg/lujing@2x (1).webp"
                                                alt="" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="user_register_operation">
                                <div class="left_box" @click="user_handoff('2')">
                                    {{ $t("navigateBar.Hasaccount")
                                    }}<text> {{ $t("navigateBar.Login") }} </text>
                                </div>
                            </div>
                            <div class="user_register_loginbtn" @click="forget_password_de(ruleFormR_pwd)">
                                {{ $t("navigateBar.Reset_Password") }}
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-drawer v-model="drawer1" destroy-on-close="true" @close="closedarw(2)">
            <div class="drawer_conent" direction="rtl" v-if="drawer1">
                <div class="Records_conent">
                    <first_header title="Records" @getValue="getValue">
                        <template #title>
                            <span>{{ $t("navigateBar.records") }}</span>
                        </template>

                    </first_header>
                    <div class="Records_top">
                        <!-- 最近游玩记录 -->
                        <div class="Records_search">
                            <input type="text" :placeholder="t('Searchbygame')"
                                @input="inputclick($event, use_recode_de)" @keydown.enter="use_recode_de()" />
                            <div class="sreach_icon">
                                <img src="@/assets/Homeimg/Icon Search@2x.webp" alt="" />
                            </div>
                        </div>
                        <!-- 时间范围筛选 -->
                        <!-- <div class="timeselect">
                            <el-config-provider :locale="ellocale">
                                <el-date-picker v-model="timerc" popper-class="date-style" type="datetimerange"
                                    range-separator="|" :start-placeholder="timefbtext.start"
                                    :end-placeholder="timefbtext.end" @change="use_recode_de" format="YYYY-MM-DD"
                                    value-format="YYYY-MM-DD" />
                            </el-config-provider>
                        </div> -->
                    </div>
                    <div class="Records_box">
                        <div class="friends_list_item" v-if="recodearr?.length <= 0">
                            <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                            <div class="bottomtext_text">
                                {{ t("Notyet") }}
                            </div>
                        </div>
                        <div v-for="(val, key) in recodearr" :key="key" v-else>
                            <div class="Favorites_list_item">
                                <div class="Favorites_list_title">{{ key }}</div>
                                <div class="Favorites_cardconent">
                                    <template v-for="(item1, index1) in recodearr[key]" :key="item1">
                                        <div class="Favorites_card">
                                            <Favoritescard :videourl="item1?.video" :imgurl="item1?.image"
                                                :gamename="item1?.name" :id="item1.id" :icon="item1.ico"
                                                :showtap="showtap" @selecttap="selecttap" :checkedblen="checkedblen" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-drawer v-model="drawer3" destroy-on-close="true" @close="closedarw(3)">
            <!-- 网站反馈 -->
            <div class="drawer_conent" direction="rtl" v-if="drawer3">
                <div class="Feedback_conent">
                    <first_header title="Feedback" @getValue="getValue">
                        <template #title>
                            <span>{{ $t("navigateBar.feedback") }}</span>
                        </template>
                    </first_header>
                    <el-form class="Feedback_box" :model="ruleForm_fb" ref="ruleFormR_Fb" :rules="rules"
                        validate-on-rule-change>
                        <div class="Feedback_item">
                            <div class="Feedback_title">{{ $t("FeebackType") }}</div>
                            <div class="Feedback_input">
                                <el-form-item prop="type">
                                    <el-select v-model="ruleForm_fb.type" :placeholder="t('plSelectfd')"
                                        popper-class="mySelectStyle">
                                        <template v-for="(item, index) in feedbackarr[fbgameblen ? 1 : 0]" :key="item">
                                            <el-option :label="item.value" :value="item.key" />
                                        </template>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="Feedback_item" v-if="fbgameblen">
                            <div class="Feedback_title">{{ $t("feebackgame") }}</div>
                            <div class="Feedback_input">
                                <el-form-item>
                                    <el-input type="text" :value="gamename" :placeholder="t('plgnsg')" readonly />
                                </el-form-item>
                            </div>
                        </div>
                        <div class="Feedback_item">
                            <div class="Feedback_title">{{ $t("Your_emall") }}</div>
                            <div class="Feedback_input">
                                <el-form-item prop="email">
                                    <el-input type="text" v-model="ruleForm_fb.email" :placeholder="t('plemail')" />
                                </el-form-item>
                            </div>
                        </div>
                        <div class="Feedback_item">
                            <div class="Feedback_title">{{ $t("Massage") }}</div>
                            <div class="Feedback_textarea">
                                <el-form-item prop="message">
                                    <el-input type="textarea" v-model="ruleForm_fb.message" textareaStyle="texts" />
                                </el-form-item>
                            </div>
                        </div>
                        <div class="Feedback_btn" @click="Feedbackon_de(ruleFormR_Fb)">
                            {{ $t("navigateBar.feedback") }}
                        </div>
                    </el-form>
                </div>
            </div>
        </el-drawer>
        <el-drawer v-model="drawer4" @close="closedarw(4)">
            <!-- 合作意向 -->
            <div class="drawer_conent" direction="rtl" v-if="drawer4">
                <div class="Feedback_conent">
                    <first_header title="Business Cooperation" @getValue="getValue">
                        <template #title>
                            <span>{{ $t("navigateBar.business_cooperation") }}</span>
                        </template>
                    </first_header>
                    <div class="Feedback_box">
                        <el-form class="Feedback_box" :model="ruleForm_bn" ref="ruleFormR_bn" :rules="rules"
                            validate-on-rule-change>
                            <div class="Feedback_item">
                                <div class="Feedback_title">{{ $t("FeebackType") }}</div>
                                <div class="Feedback_input">
                                    <el-form-item prop="type">
                                        <el-select v-model="ruleForm_bn.type" :placeholder="t('plSelectfd')"
                                            popper-class="mySelectStyle">
                                            <template v-for="(item, index) in perationTypearr" :key="item">
                                                <el-option :label="item.value" :value="item.key" />
                                            </template>
                                            <!-- feedbackarr -->
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="Feedback_item">
                                <div class="Feedback_title">{{ $t("Phoneoptional") }}</div>
                                <div class="Feedback_input">
                                    <el-form-item prop="phone">
                                        <el-input type="text" v-model="ruleForm_bn.phone"
                                            :placeholder="t('PlIyophone')" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="Feedback_item">
                                <div class="Feedback_title">{{ $t("Your_emall") }}</div>
                                <div class="Feedback_input">
                                    <el-form-item prop="email">
                                        <el-input type="text" v-model="ruleForm_bn.email" :placeholder="t('plemail')" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="Feedback_item">
                                <div class="Feedback_title">{{ $t("Massage") }}</div>
                                <div class="Feedback_textarea">
                                    <el-form-item prop="message">
                                        <el-input type="textarea" v-model="ruleForm_bn.message" textareaStyle="texts" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="Feedback_btn" @click="businesstap_de(ruleFormR_bn)">
                                {{ $t("Submit") }}
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-dialog v-model="dialogblen" :show-close="false" class="fsdialog" center>
            <div class="conetbox">
                <img src="@/assets/Homeimg/erroricon.webp" alt="" />
                <p>{{ $t("navigateBar.twdya") }}</p>
                <div class="btnbox">
                    <div class="left_btn btn" @click="del_account_de()">
                        {{ $t("navigateBar.Confirm") }}
                    </div>
                    <div class="right_btn btn" @click="dialogblencancel()">
                        {{ $t("navigateBar.Cancel") }}
                    </div>
                </div>
            </div>
        </el-dialog>




    </div>
</template>
<script setup lang="ts">
import {
    ref,
    onMounted,
    onBeforeUnmount,
    watch,
    computed,
    reactive,
    nextTick,
    onActivated,
    provide
} from "vue";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
//el国际化
const ellocale = ref<any>(zhCn);

import { Plus } from "@element-plus/icons-vue";
import type {
    DrawerProps,
    FormInstance,
    FormRules,
    ArrowDown,
    UploadProps,
} from "element-plus";
const direction = ref<DrawerProps["direction"]>("rtl");
import first_header from "@/moblie-components/mb_header/first_header.vue";
import first_icon from "@/components/first_comlist/first_icon.vue";
import first_headerback from "@/moblie-components/mb_henderback/first_headerback.vue";
import Nothingbox from '@/moblie-components/noting/noting_c.vue';
import friends_card from "@/moblie-components/Friends_card/fitst_friends_card.vue";

import useCard from "@/components/first_comlist/use_cardlist/use_card/swipercard.vue";
import Favoritescard from "@/moblie-components/Favorites_card/card_meta.vue";
import Card_meta from '@/moblie-components/cardAll/cardmeta.vue'
import CookieBannerMobile from '@/moblie-components/cookie-banner/cookie-banner-mobile.vue';

import { debounce, throttle } from "@/utils/utils.ts";
// //导入i8n
import { useI18n } from "vue-i18n";
// // 实例化i8n
const { t, locale } = useI18n();
import {
    getcategories_list,
    get_ems,
    useRegister,
    use_logoin,
    use_authorize,
    use_logout,
    use_resetpwd,
    use_profile,
    use_attachment,
    use_friend,
    use_received,
    use_sent,
    use_favorite,
    use_addFavorite,
    use_delFavorite,
    use_recode,
    get_getSeachWord,
    get_feedbackType,
    get_cooperationType,
    get_feedback,
    get_business,
    use_deAccount,
    use_autologin,
} from "@/request/request.ts";
import { ElMessage } from "element-plus";
import encrypt from "@/utils/crypto-util.ts";
import vueQr from "vue-qr/src/packages/vue-qr.vue";



// 侧边栏第三方icon
const thirdpartyarr = ref([
    { url: 'img/titok@2x.png', name: 'titak' },
    {
        url: 'img/socials@2x.png',
        name: 'youtube',
        path: 'https://www.youtube.com/@iGlees',
    },
    // { url: 'img/socials1.webp', name: 'fceebook' },
    { url: 'img/X@2x1.webp', name: 'x', path: 'https://x.com/iGleesOfficial' },
    // { url: 'img/ins2x.png', name: 'ins' },
    // { url: 'img/socials (1)-1.webp', name: 'ins' },
]);
// 第三方平台官网跳转
const thirdparty_click = (index: any) => {
    logEventAnalytics("c_third_platform", {
        type: index + 1,
    })
    console.log('第三方平台官网跳转');
    if (thirdpartyarr.value[index]?.path) {
        const url = thirdpartyarr.value[index]?.path// 你想打开的第三方网页 URL
        // 打开新窗口并加载网页
        window.open(url, '_blank');
    }

};

const Userclick = (item: any) => {
    console.log(item.id, '游戏详情');
    logEventAnalytics("c_game", {
        gid: item.id,
        type: "2",
    })
}

const Ftclick = (item: any) => {
    console.log(item, '游戏详情');
    logEventAnalytics("c_game", {
        gid: item.id,
        type: "3",
    })
}

//报错监听测试 立即执行函数
// (function(){
//   setTimeout(() => {
// throw new Error('错误检测测试`11111111111111')
//   }, 5000);
// })()

// let a = null;
// if (a.length > 1) {
//   // ...
// }

// const showSearch=ref(false)

const nothingboxblen = ref(false)

const textsreach = ref('')

const getImgInfo = (data: any) => {
    console.log(111, data);
};
import { useNewpageData } from "@/stroe/pinia.ts";
//导入pinia
const NewpageData = useNewpageData();
// 时间变量1
const timefb = ref<any>("");
//文档字体国际化
const timefbtext = computed(() => {
    return {
        start: t("statrtime"),
        end: t("endtime"),
        to: t("timetogo"),
    };
});
// 时间变量2
const timerc = ref<any>("");
const showSearch = ref<any>('-100%')
const router = useRouter();
const route = useRoute();
const useloginblen = ref<any>(false);
const drawer2 = ref(false);
const drawer3 = ref(false);
const drawer1 = ref(false);
const drawer4 = ref(false);

// VConsole 调试功能相关变量
const clickCount = ref<number>(0);
const lastClickTime = ref<number>(0);
const vconsoleLoaded = ref<boolean>(false);
const clickTimer = ref<NodeJS.Timeout | null>(null);
const textall = ref("");
const maskblen = ref<any>(false);
const selectedindex = ref<any>("Home");
const Collapseblen = ref<any>(false);
const displayblock = ref<any>("block");
const outerDom = ref();
const sectionRef = ref();
const btnblock = ref(false);
const clientWidth = ref(true);
const leftwith = ref(191);
const Optionsindex = ref<any>("0");
const sreactblen = ref<any>(false);
const sreacloading = ref<any>(false);
// ///////// 导入i18n
const i18nvalue = ref<any>("");
const options = [
    {
        value: "en",
        label: "English",
    },
    {
        value: "zh",
        label: "简体中文",
    },
];
if (localStorage.getItem("Pfdlanguage")) {
    i18nvalue.value = localStorage.getItem("Pfdlanguage");
}
// 切换语言
const changeLang = (data: any) => {
    locale.value = data;
    logEventAnalytics("c_language", {
        language: data,
    })
    //存储语言选择
    localStorage.setItem("Pfdlanguage", data);
    console.log(i18nvalue.value);
};
//用户好友列表 friendsarr friendgetarr friendsetarr
const friendsarr = ref<any>([]);
//用户收到好友请求列表
const friendgetarr = ref<any>([]);
//用户发送好友请求列表
const friendsetarr = ref<any>([]);
// 跳转到登录
const gotologin = () => {
    openindex.value = "3";
};
//登录loading
const useloading = ref(false);
const input = ref("");
const openindex = ref<any>("");
const useChage = ref<any>(false);
const inputRef = ref<any>("");
const usedata = ref<any>({
    nickname: "",
    avatar: "",
});
//'首次页面加载进入渠道
if (route.query) {
    console.log('首次页面加载进入渠道——————————————————————————————————————', route.query.channel);
    logEventAnalytics("e_page_load", {
        channel: route.query?.channel,
        referrer: route.query?.referrer,
    })
}
// 过滤本地清除本地
const clearLocalStorageExcept = (keysToKeep: any) => {
    // 创建一个临时对象来存储需要保留的键值对
    const tempStorage = {};

    // 遍历 localStorage 中的所有键
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (keysToKeep.includes(key)) {
            // 如果键在需要保留的列表中，将其存储在临时对象中
            tempStorage[key] = localStorage.getItem(key);
        }
    }
    // 清除 localStorage
    localStorage.clear();

    // 将临时对象中的键值对重新存储到 localStorage 中
    for (const key in tempStorage) {
        if (tempStorage.hasOwnProperty(key)) {
            localStorage.setItem(key, tempStorage[key]);
        }
    }
}

/**
 * 导入firebase 监听函数
 */
import { logEventAnalytics } from '@/Firebase/firebase';

//顶部选中
const onmouse = ref<any>(null);
//监听是否token过期 或者用户消失
watch(NewpageData, (newState) => {
    if (newState.tokenblen) {
        console.log("用户保持登录状态");
        // 在这里可以执行其他页面的函数
    } else {
        console.log("用户登录状态过期执行清除");
        // localStorage.clear();
        clearLocalStorageExcept(['Pfdlanguage'])



        usefromdata.value = {};
        user_handoff("2");
        useloginblen.value = false;
    }
});

/** google登录 */
//  Loginsuccessful: "登录成功",
// /Login failed
// Loginfailed: "登录失败",
const Loginfailed = computed(() => t("Loginfailed"));
const Loginsuccessful = computed(() => t("Loginsuccessful"));
const googleSignCallBack = async (googleUser: any) => {


    logEventAnalytics("c_login", {
        type: '2',
    });
    console.log("googleUser,返回信息", googleUser);
    useloading.value = true;
    console.log(
        {
            type: 1,
            clientId: googleUser.clientId,
            credential: googleUser.credential,
        },
        "谷歌数据"
    );
    try {
        let res = await use_autologin({
            type: 1,
            clientId: googleUser.clientId,
            credential: googleUser.credential,
        });
        if (res.status == 1) {
            console.log("登录成功", res);
            usefromdata.value = res.data;
            localStorage.setItem("usetoken", res.token);
            useloading.value = false;
            ElMessage.success({
                message: Loginsuccessful,
            });
            useloginblen.value = true;
            user_handoff("1");
        } else {
            console.log("登录失败", res);

            useloading.value = false;
            ElMessage.error({
                message: Loginfailed,
            });
        }
    } catch (error) {
        throw error
    }
};
/**
 * 脸书 登录 Facebook 登录
 */
const fbSignInParams = ref<any>({
    scope: "email,user_likes",
    return_scopes: true,
});
const FBlogin = () => {
    FB.login(function (response) {
        console.log(response, "脸书登录");
    });
};
const onSignInSuccess = (response: any) => {
    // https://developers.facebook.com/docs/graph-api/reference/user
    FB.api(
        "/me?fields=id,name,gender,first_name,last_name,email,birthday,hometown",
        (dude) => {
            console.log(`Good to see you, ${dude}.`);
        }
    );
    console.log(response); //返回第三方的登录信息 tolen等
};
const onSignInError = (error: any) => {
    console.log(error);
};
/**
 *  推特第三方登录
 */
import hello from "hellojs/dist/hello.all.js";
const TWlogin = () => {
    hello("twitter").login();
    // Listen to signin requests
    hello.on("auth.login", function (r) {
        // Get Profile
        hello(r.network)
            .api("/me")
            .then(function (p) {
                window.console.log(p); //输出用户信息
            });
    });
};
const TWws = () => {
    hello.init(
        {
            twitter: "REm8KjWsthsmKXZoVIYXNn1qqy",
        },
        {
            scope: "email",
            redirect_uri: "http://localhost:3002/",
        }
    );
};
onMounted(() => {
    /**推特谷歌方法调用 */
    window.googleSignCallBack = googleSignCallBack;
    /**推特方法调用 */
    TWws();
    // 路由刷新重置距离顶部高度
    router.afterEach(Scrollres);
});

const checkdata = ref<any>("");
const datada = () => {
    console.log("变化", checkdata.value);
};
//蒙层关闭
const opendel = () => {
    maskblen.value = !maskblen.value;
    textSeach.value = "";
};
//自动聚焦
const forucson = () => {
    nextTick(() => {
        inputRef.value.focus();
    });
};
//更改用户信息
const use_change = async () => {
    useloading.value = true;
    console.log(usedata.value, useloading.value, "用户信息");
    try {
        let res = await use_profile({
            ...usedata.value,
        });
        if (res.status == 1) {
            useloading.value = false;
            get_use_info();
            console.log("修改成功", res);
        } else {
            useloading.value = false;
            console.log("修改失败", res);
        }
    } catch (error) {
        throw error
    }
};

// 用户信息更改选择
const handleCommand = (command: string | number | object) => {



    console.log(command);
    console.log("进行修改信息");
    useChage.value = !useChage.value;
    if (command == "2") {
        logEventAnalytics("c_user_menu", {

            type: "1",
            btnid: "1",
        })


        console.log("自动聚焦", inputRef);
        forucson();
        if (
            usedata.value.nickname !== usefromdata.value.nickname ||
            usedata.value.avatar !== usefromdata.value.avatar
        ) {
            usedata.value.nickname = usefromdata.value.nickname;
            usedata.value.avatar = usefromdata.value.avatar;
            console.log("进行赋值", usedata.value);
        }
    } else {
        if (
            usedata.value.nickname !== usefromdata.value.nickname ||
            usedata.value.avatar !== usefromdata.value.avatar
        ) {
            console.log("发送更新", usedata.value);
            use_change();
        } else {
            console.log("无更新", usedata.value);
        }
    }
};

//头像上传
const uploudmian = async (e: any) => {
    let file = e.target.files[0];
    console.log(file);
    if (file.size / 1024 / 1024 > 2) {
        ElMessage.error("Avatar picture size can not exceed 2MB!");
        return false;
    } else {
        // 上传文件 创建FormData
        let formData = new FormData();
        // upFile就是后台接收的key
        formData.append("file", file);
        console.log(formData);
        try {
            let res = await use_attachment(formData);
            console.log(res, "上传头像");
            if (res.status == 1) {
                console.log(res, "上传头像成功");
                usedata.value.avatar = res.data;
            }
        } catch (error) {
            throw error
        }
    }
};

// 控制用户页面状态 1:用户详情 2:登录 3:注册 4:修改密码
const user_state = ref<any>("2");
//有本地token自动登录 qE@12345
const get_use_info = async () => {
    try {
        let res = await use_authorize({});
        console.log(res);
        if (res.status == 1) {
            console.log(res.data, "自动登录成功");
            usefromdata.value = res.data;
            useloginblen.value = true;
        }
    } catch (error) {
        throw error
    }
};


console.log(localStorage.getItem("usetoken"));
if (localStorage.getItem("usetoken")) {
    console.log("用户已登录");
    user_state.value = "1";
    useloginblen.value = true;
    get_use_info();
} else {
    console.log("用户未登录");
    user_state.value = "2";
    useloginblen.value = false;
}


// //////////////////////////
const categories_list = ref<any>([]);
// 获取侧边栏 游戏分类tap
const getlist = async () => {
    try {
        let res = await getcategories_list();
        if (res.status == 1) {
            // console.log(res, '获取侧边栏数据成功');
            categories_list.value = res.data;
            console.log(categories_list.value, "获取侧边栏数据成功");
        }
    } catch (error) {
        throw error
    }
};
getlist();
console.log(route, "路由数据");
// 关闭抽屉
const getValue = (e: any) => {
    console.log(e);
    drawer3.value = false;
    drawer2.value = false;
    drawer1.value = false;
    drawer4.value = false;
};

// VConsole 调试功能相关方法
const handleHeaderClick = (event: Event) => {
    // 如果 VConsole 已经加载，则不再处理点击事件
    if (vconsoleLoaded.value) {
        return;
    }

    const currentTime = Date.now();

    // 检查时间间隔
    if (lastClickTime.value > 0 && currentTime - lastClickTime.value > 1000) {
        // 超过1秒，重置计数器
        clickCount.value = 0;
        if (clickTimer.value) {
            clearTimeout(clickTimer.value);
            clickTimer.value = null;
        }
    }

    // 更新点击计数和时间
    clickCount.value++;
    lastClickTime.value = currentTime;

    console.log(`顶部栏点击次数: ${clickCount.value}`);

    // 如果达到5次点击，加载 VConsole
    if (clickCount.value >= 5) {
        loadVConsole();
        return;
    }

    // 设置定时器，1秒后重置计数器
    if (clickTimer.value) {
        clearTimeout(clickTimer.value);
    }
    clickTimer.value = setTimeout(() => {
        clickCount.value = 0;
        lastClickTime.value = 0;
        clickTimer.value = null;
    }, 1000);
};

const loadVConsole = () => {
    // 防止重复加载
    if (vconsoleLoaded.value) {
        return;
    }

    console.log('开始加载 VConsole...');

    // 创建 script 标签
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';

    // 监听加载完成事件
    script.onload = () => {
        console.log('VConsole 脚本加载成功，正在初始化...');
        // 初始化 VConsole
        try {
            // @ts-ignore
            const vConsole = new window.VConsole();
            console.log('VConsole 初始化成功！');

            // 标记为已加载，永久禁用此功能
            vconsoleLoaded.value = true;

            // 通过 Pinia 更新全局状态，通知其他组件
            NewpageData.setVConsoleActivated(true);
            // NewpageData.setDebugModeEnabled(true);

            // 清理定时器和重置计数器
            if (clickTimer.value) {
                clearTimeout(clickTimer.value);
                clickTimer.value = null;
            }
            clickCount.value = 0;
            lastClickTime.value = 0;

        } catch (error) {
            console.error('VConsole 初始化失败:', error);
        }
    };

    // 监听加载失败事件
    script.onerror = () => {
        console.error('VConsole 脚本加载失败');
    };

    // 将 script 标签添加到 head
    document.head.appendChild(script);
};
// 监听路由变化
watch(
    route,
    (newvalue, oldvalue) => {
        console.log(newvalue, "路由产生变化");
        //重置高度

        getValue(1);
        if (newvalue.params.name) {
            selectedindex.value = newvalue.params.name;
        } else {
            selectedindex.value =
                selectedindex.value !== newvalue.meta.title
                    ? newvalue.meta.title
                    : selectedindex.value;
        }
        if (newvalue.fullPath !== "/Message") {
            onmouse.value = null;
            console.log("不等于消息页面");
        } else {
            console.log("等于消息页面");
        }
        console.log(selectedindex, "选中变化");
    },
    { immediate: true }
);
// 用户页面返回
const user_back = () => {
    console.log('用户页面返回，重置倒计时');
    resetEmailCountdown();
    user_state.value = 2;
};
// 更新用户页面状态
const user_handoff = (num: any) => {
    console.log(`用户状态切换: ${user_state.value} -> ${num}`);

    // 重置邮箱验证码倒计时
    resetEmailCountdown();

    // 更新用户状态
    user_state.value = num;

    // 重置表单数据
    ruleForm.value = {
        email: "",
        password: "",
        captcha: "",
        setype: [],
    };

    console.log('用户状态切换完成，倒计时已重置');
};
onMounted(() => {
    console.log("dom挂载");
    window.addEventListener("scroll", handleScrollDebounced, true);
});

// 组件卸载前清理定时器
onBeforeUnmount(() => {
    console.log('组件卸载，清理邮箱验证码倒计时');
    resetEmailCountdown();
    window.removeEventListener("scroll", handleScrollDebounced, true);

    // 清理 VConsole 相关定时器
    if (clickTimer.value) {
        clearTimeout(clickTimer.value);
        clickTimer.value = null;
    }
});
//控制显示隐藏
const opacityctrl = ref('0');

// 立即隐藏按钮的函数
const hideButton = () => {
    opacityctrl.value = '0';
};

// 延迟显示按钮的函数
const showButtonDelayed = debounce(() => {
    if (outerDom.value?.scrollTop >= 200) {
        btnblock.value = true;
        setTimeout(() => {
            opacityctrl.value = '1';
        }, 300);
    } else {
        btnblock.value = false;
    }
}, 500, false);

// 滚动事件处理函数
const handleScroll = () => {
    // 立即隐藏按钮
    hideButton();
    // 延迟检查是否应该显示按钮
    showButtonDelayed();
};

onMounted(() => {
    console.log("dom挂载");
    window.addEventListener("scroll", handleScroll, true);
});

onBeforeUnmount(() => {
    console.log('组件卸载，清理事件监听和定时器');
    resetEmailCountdown();
    window.removeEventListener("scroll", handleScroll, true);

    // 清理 VConsole 相关定时器
    if (clickTimer.value) {
        clearTimeout(clickTimer.value);
        clickTimer.value = null;
    }
});
//重置到顶部
const Scrollres = () => {
    outerDom.value.scrollTop = 0;
};
// 返回顶部
const backTop = () => {
    const timeTop = setInterval(() => {
        outerDom.value.scrollTop = outerDom.value.scrollTop -= 50;
        if (outerDom.value?.scrollTop <= 0) {
            console.log(111);
            clearInterval(timeTop);
        }
    }, 15);
};
// 顶部搜索
const textSeach = ref<any>("");
const keywordarr = ref<any>([]);
const getSeachWord_de = debounce(
    (e: any) => {
        footerinput(e);
    },
    300,
    false
);
const footerinput = (e: any) => {
    console.log('搜索', e.target.value);
    maskblen.value = true;
    if (e.target.value) {
        console.log("通过非空验证", e.target.value);
        getSeachWord(e.target.value);

    } else {
        sreactblen.value = false
        keywordarr.value = [];
    }
};
const footerinputblur = (e: any) => {
    console.log(e.target.value);
    e.target.value = "";
    maskblen.value = false;
    keywordarr.value = [];
};
//搜索请求
const getSeachWord = async (text: any) => {
    console.log("当前关键词", text);
    sreactblen.value = true;
    sreacloading.value = true;
    keywordarr.value = [];
    try {
        let res = await get_getSeachWord({ keyword: text });
        if (res.status == 1) {
            sreactblen.value = true;
            sreacloading.value = false
            console.log(res.data, "搜索结果");
            if (res.data.length > 0) {
                keywordarr.value = res.data
                nothingboxblen.value = false
            } else {
                sreacloading.value = false
                nothingboxblen.value = true
            }

        } else {
            sreactblen.value = false
            sreacloading.value = false
            ElMessage.error(res.msg);
        }
    } catch (error) {
        sreactblen.value = false;
        sreacloading.value = false
        console.log(error);
        throw error;
    }
};
// 字段搜索 页面跳转
const search_input = (e: any) => {
    console.log(`/Search/${e.target.value}`);


    if (e.target.value) {

        logEventAnalytics("c_search", {
            type: '1',
            keyword: e.target.value,
        })

        showSearch.value = '-100%'
        keywordarr.value = [];
        sreactblen.value = false
        console.log("写入");
        history_chage(e.target.value);
        router.push({ path: `/Search/${e.target.value}` });
    }
};
// 搜索结果跳转
const go_details = (data: any) => {
    showSearch.value = '-100%'
    keywordarr.value = [];
    sreactblen.value = false
    history_chage(data.name);
    maskblen.value = false;
    textSeach.value = "";
    router.push({ path: `/GameDetails/${data.id}` });
};
//router.push({ path: `/GameDetails/${data.id}` });

/**
 * 更多内容跳转
 */

const more_click = (index: any) => {
    console.log(index, "更多内容跳转");
    if (index == 1) {
        console.log('打开 最近玩过');
        drawer1.value = true
        drawer3.value = false;
        drawer2.value = false;
        drawer4.value = false;


    }
    if (index == 2) {
        console.log('打开 我的收藏');
        openindex.value = '1'

        // router.push({ path: `/GameDetails/${data.id}` });
    }
};

// 历史记录填充
const history_fill = (text: any) => {
    textSeach.value = text;
    search_input();
};
//写入 读取本地搜索历史
const local_searcharr = ref<any>([]);
// 读取
const get_history = () => {
    console.log(localStorage.getItem("historylist"), "读取历史");
    if (localStorage.getItem("historylist")) {
        local_searcharr.value = JSON.parse(localStorage.getItem("historylist"));
    }
};
get_history();
// 写入本地历史
function cut(value: any) {
    return value.slice(0, value.length - 1);
}
const history_chage = (text: any) => {
    if (local_searcharr.value.indexOf(text) == -1) {
        console.log(text, "写入历史");
        if (local_searcharr.value.length == 6) {
            local_searcharr.value = cut(local_searcharr.value);
            local_searcharr.value.unshift(text);
        } else {
            local_searcharr.value.unshift(text);
        }
        localStorage.setItem("historylist", JSON.stringify(local_searcharr.value));
    } else {
        return;
    }
};
////////////////////////////////////////固定分类icon
const Sidebararr = computed(() => [
    {
        selected_icon: "apps-2-line 1@2x.webp",
        unchecked_icon: "apps-2-line 1@2x (2).webp",
        name: t("navigateBar.Home"),
        title: "Home",
        bg: 'linear-gradient(180deg, #6AD0FF 0%, #0071C2 100%)'
        // HOME
    },
    {
        selected_icon: "history-line@2x (1).webp",
        unchecked_icon: "apps-2-line 2@2x (1).webp",
        // name: "Reconds",
        name: t("navigateBar.records"),
        title: "Reconds",
        bg: 'linear-gradient(180deg, #FFD634 2%, #DC8400 100%)'
    },
    {
        selected_icon: "map-line@2x (1).webp",
        unchecked_icon: "apps-2-line 1@2x (3).webp",
        // name: "New",
        name: t("navigateBar.New"),
        title: "New",
        bg: 'linear-gradient(180deg, #FF6AD2 0%, #A70358 95%)'
    },
    {
        selected_icon: 'fire-line@2x (1).webp',
        unchecked_icon: 'fire-line@2x (2).webp',
        // name: "Hot",
        name: t("navigateBar.Hot"),
        title: "Hot",
        bg: ' linear-gradient(180deg, #AB6AFF 0%, #4E00C2 100%)'
    },
    {
        selected_icon: "bookmark-line@2x (1).webp",
        unchecked_icon: "fire-fill@2x (1).webp",
        // name: "Rank",
        name: t("navigateBar.Rank"),
        title: "Rank",
        bg: ' linear-gradient(180deg, #72FF6A 0%, #05982C 97%)'
    },
])
const Calegoriesarr = ref([
    {
        selected_icon: "skull-line@2x (1).webp",
        unchecked_icon: "skull-line@2x.webp",
        name: "Action",
    },
    {
        selected_icon: "basketball-line@2x (1).webp",
        unchecked_icon: "basketball-line@2x.webp",
        name: "Sports",
    },
    {
        selected_icon: "plant-line@2x (1).webp",
        unchecked_icon: "plant-line@2x.webp",
        name: "Puzzle",
    },
    {
        selected_icon: "infrared-thermometer-line@2x (1).webp",
        unchecked_icon: "infrared-thermometer-line@2x.webp",
        name: "Shooting",
    },
    {
        selected_icon: "flag-2-line@2x (1).webp",
        unchecked_icon: "flag-2-line@2x.webp",
        name: "Adventure",
    },
    {
        selected_icon: "bank-card-line@2x (1).webp",
        unchecked_icon: "bank-card-line@2x.webp",
        name: "Card",
    },
    {
        selected_icon: "file-2-line@2x (1).webp",
        unchecked_icon: "file-2-line@2x.webp",
        name: "Strategy",
    },
    {
        selected_icon: "gamepad-line@2x (1).webp",
        unchecked_icon: "gamepad-line@2x.webp",
        name: "Leisure",
    },
    {
        selected_icon: "t-shirt-fill@2x (1).webp",
        unchecked_icon: "t-shirt-fill@2x.webp",
        name: "Beauty",
    },
    {
        selected_icon: "group-line@2x (1).webp",
        unchecked_icon: "group-line@2x.webp",
        name: "2 Player",
    },
]);
// t("navigateBar.rank")
const aboutlistarr = computed(() => [
    t("navigateBar.about_us"),
    // t("navigateBar.contact_us"),
    t("navigateBar.feedback"),
    t("navigateBar.fqa"),
    t("navigateBar.user_privacy"),
    t("navigateBar.sbervice_Terms"),
    t("navigateBar.business_cooperation"),
    t("navigateBar.developers"),
]);

const aboutlist_item_click = (index: any) => {
    console.log(index);
    logEventAnalytics("c_about", {
        aid: index + 1
    })


    if (index == "1") {
        drawer3.value = true;
    }
    if (index == "5") {
        drawer4.value = true;
    }
};
// 侧边栏点击处理
const selectedclick = (index: any) => {
    console.log(index, "侧边栏点击");
    showSearch.value = '-100%'
    if (index !== null) {
        selectedindex.value = index.name ? index.name : index;
    }
    if (index == "Reconds") {
        if (useloginblen.value) {
            console.log("________________");
            use_recode_de();
            drawer1.value = true;
        } else {
            drawer2.value = true;
            openindex.value = "3";
        }
    } else {
        console.log(selectedindex.value, "当前选中");
        if (selectedindex.value == "Home") {
            router.push("/Home");
        } else if (
            selectedindex.value == "New" ||
            selectedindex.value == "Hot" ||
            selectedindex.value == "Rank"
        ) {
            // 点击导航栏
            logEventAnalytics("c_navigation", {
                nid: index + 1,
            })
            router.push({ path: `/Categories/${index.name ? index.name : index}` });
        } else {
            //点击游戏分类
            logEventAnalytics("c_categories", {
                cid: index.id,
            })
            router.push({
                path: `/ClassificationDetails/${index.id}/${index.name ? index.name : index
                    }`,
            });
        }
    }
};
// 侧边栏第三方icon

//第三方登录 icon
const thirdparty_login = ref([
    { url: "img/socials1.webp", name: "fceebook" },
    { url: "img/socials@2x (1).png", name: "ins" },
    { url: "img/组 36@2x.png", name: "ins" },
]);
// 顶部用户栏 icon
const usericonarr = ref([
    {
        slurl: "user-heart-fill@2x.webp",
        unurl: "user-heart-line@2x.webp",
        name: "user",
    },
    {
        slurl: "heart-fill@2x.webp",
        unurl: "heart-3-line@2x.webp",
        name: "user",
    },
    {
        slurl: "notification-2-fill@2x.webp",
        unurl: "notification-2-line@2x.webp",
        name: "user",
    },
    {
        slurl: "user-fill@2x.webp",
        unurl: "user-line@2x.webp",
        name: "user",
    },
]);
watch(
    drawer2,
    (newvalue, oldvalue) => {
        console.log(newvalue, "抽屉产生变化");
        if (newvalue) {
        } else {
            // onmouse.value = null
        }
    },
    { immediate: true }
);
const righCollapse = () => {
    console.log("被点击了");
    Collapseblen.value = !Collapseblen.value;
    displayblock.value = Collapseblen.value ? "none" : "block";
};
//onouchstart="gtouchstart(id)" ontouchend="gtouchend()"
const getImageUrl = (url: any) => {
    return new URL(url, import.meta.url).href;
};
const onSwiper = (swiper: any) => {
    console.log(swiper);
};
// 打开顶部抽屉
const open = async (index: any) => {
    console.log(useloginblen.value);
    if (index == "0" || index == "1" || index == "3") {
        drawer2.value = true;
        if (useloginblen.value) {
            openindex.value = index;
            console.log(openindex.value, "打开抽屉");
            try {
                switch (openindex.value) {
                    case 0:
                        await Get_use_FriendInfo_All();
                        break;
                    case 1:
                        await get_use_collect();
                        break;
                    case 3:
                        await get_use_info();
                        break;
                    default:
                        break;
                }
            } catch (error) {
                throw error
            }


        } else {
            if (index == "0") {
                openindex.value = "0";
            } else {
                openindex.value = "3";
            }
        }
    } else if (index == "2") {
        console.log(index);
        if (useloginblen.value) {
            onmouse.value = index;
            router.push("/Message");
        } else {
            drawer2.value = true;
            openindex.value = "3";
            console.log(index, openindex.value);
        }
    }
};
// 抽屉搜索
const inputclick = (e: any, callback: any) => {
    textall.value = e.target.value;
    console.log(textall.value);
    // if (textall.value !== '') {
    callback();
    // }
};
// 好友底部选项数组
const oparr = computed(() => [t("List"), t("Received"), t("Sent"), t("Mine")]);
//用户社交信息全获取
const Get_use_FriendInfo_All = async () => {
    let newarr: any = [];
    try {
        newarr = await Promise.all([
            use_friend({}),
            use_received({}),
            use_sent({}),
        ]);
        let [data1, data2, data3] = newarr;
        console.log(data1, data2, data3, "获取成功");
        // friendsarr friendgetarr friendsetarr
        friendsarr.value = data1.data;
        friendgetarr.value = data2.data;
        friendsetarr.value = data3.data;
    } catch (error) {
        throw error
    }
};
/**
 * 点击分享个人资料
 */
const Friend_Share = () => {
    let uid = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
    logEventAnalytics("c_user_menu", {
        uid: uid,
        type: "4",
        btnid: "5",
        platform: "pc"
    })

}
/**
 * 
 * Friend_Copy 复制资料
 */
const Friend_Copy = () => {
    let uid = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
    logEventAnalytics("c_user_menu", {
        uid: uid,
        type: "4",
        btnid: "6",
        platform: "pc"
    })
}

// 选择好友选项
const Options_click = (index: any) => {
    logEventAnalytics("c_user_menu", {
        type: "4",
        btnid: index + 1,
    })
    console.log(index);

    Optionsindex.value = index;

    // if (index == 0) {
    //   get_use_friend()
    // } else if (index == 1) {
    //   get_use_received()
    // } else if (index == 2) {
    //   get_use_sent()
    // }
};
// 监听朋友选项变化
// watch(Optionsindex, (newvalue, oldvalue) => {
//   console.log(newvalue, '好友选择产生变化');
// });
const User_Information_text_arr = ref([
    "Friends",
    "Favorites",
    "Game Played",
    "Game Liked",
]);

const mouseOver = (index: any) => {
    // console.log("移入");
    onmouse.value = index;
};
const mouseLeave = (index: any) => {
    // console.log("移出");
    onmouse.value = null;
};
// 表单

const ruleFormRef = ref<FormInstance>();
const ruleFormR_re = ref<FormInstance>();
const ruleFormR_pwd = ref<FormInstance>();
const ruleFormR_Fb = ref<FormInstance>();
const ruleFormR_bn = ref<FormInstance>();

//抽屉关闭回调 清除数据
const closedarw = (data: any) => {
    console.log(data, "关闭抽屉", ruleForm_bn.value?.email);

    // 如果关闭的是登录相关抽屉（drawer2包含登录模块），重置邮箱验证码倒计时
    if (data === 1) {
        console.log('关闭登录抽屉，重置邮箱验证码倒计时');
        resetEmailCountdown();
    }

    ruleFormRef.value?.resetFields();
    ruleFormR_Fb.value?.resetFields();
    ruleFormR_bn.value?.resetFields();
    timefb.value = "";
    // ruleForm_fb.value?.resetFields();
    Fidarr.value = [];
    fbgameblen.value = "";
    showtap.value = false;
};
// 正则表达式
const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
// 密码校验
const passwordruler = (pass: any) => {
    return regex.test(pass);
};
// ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!%*?&])[A-Za-z\d@!%*?&]{8,}$
// 用户登录 参数
const ruleForm = ref<any>({
    email: "",
    password: "",
    captcha: "",
    setype: [],
});
//用户反馈参数
const ruleForm_fb = ref<any>({
    type: "",
    game_id: "",
    email: "",
    message: "",
    phone: "",
});
//用户合作参数
const ruleForm_bn = ref<any>({
    type: "",
    game_id: "",
    email: "",
    message: "",
    phone: "",
});

//email校验规则 (登录注册用，必填)
const validate_email = (rule: any, value: any, callback: any) => {
    if (!value) {
        console.log("请输入邮箱");
        callback(new Error(t("plemail")));
        return;
    }

    // 验证邮箱格式
    if (!isValidEmail(value)) {
        console.log("邮箱格式不正确");
        callback(new Error(t("emailformat")));
        return;
    }

    callback();
};

//email校验规则 (反馈合作用，选填)
const validate_email_optional = (rule: any, value: any, callback: any) => {
    // 如果邮箱为空，直接通过验证（选填）
    if (!value) {
        callback();
        return;
    }

    // 如果有值，验证邮箱格式
    if (!isValidEmail(value)) {
        console.log("邮箱格式不正确");
        callback(new Error(t("emailformat")));
        return;
    }

    callback();
};
//password校验规则
const validate_password = (rule: any, value: any, callback: any) => {
    if (!value) {
        console.log("请输入密码");
        callback(new Error(t("plpassword")));
    } else {
        if (passwordruler(value)) {
            callback();
            console.log("校验正确");
        } else {
            console.log("密码格式错误");
            callback(new Error(t("passwordage")));
            //password
        }
    }
    callback();
};
// 验证码校验规则
const vidate_captcha = (rule: any, value: any, callback: any) => {
    if (!value) {
        console.log("请输入密码");
        callback(new Error(t("plemailcode")));
    } else {
        callback();
    }
    callback();
};
// 用户协议校验
const validate_type = (rule: any, value: any, callback: any) => {
    console.log(value);
    if (!value || value.length < 1) {
        ElMessage.warning({
            message: t("UserAgreement"),
            type: "error",
        });
        callback();
    } else {
        callback();
    }
    callback();
};
//反馈类型校验
const validate_fbtype = (rule: any, value: any, callback: any) => {
    console.log(value);
    if (!value) {
        console.log("选择反馈类型");
        callback(new Error(t("plSelectfd")));
    } else {
        callback();
    }
    callback();
};
// 反馈信息校验
const validate_message = (rule: any, value: any, callback: any) => {
    console.log(value);
    if (!value) {
        console.log("请输入您的反馈信息");
        callback(new Error(t("plfbmes")));
    } else {
        callback();
    }
    callback();
};
// 合作电话校验 (必填)
const validate_phone = (rule: any, value: any, callback: any) => {
    console.log(value);
    if (!value) {
        console.log("请输入您的电话号码");
        callback(new Error(t("plphone")));
    } else {
        callback();
    }
    callback();
};

// 合作电话校验 (选填)
const validate_phone_optional = (rule: any, value: any, callback: any) => {
    console.log(value);
    // 如果电话为空，直接通过验证（选填）
    if (!value) {
        callback();
        return;
    }

    // 如果有值，验证电话格式
    if (!isValidPhone(value)) {
        console.log("电话格式错误");
        callback(new Error(t("phoneformat")));
        return;
    }

    callback();
};

//input校验规则 (反馈合作用，邮箱电话选填)
const rules = reactive<FormRules<typeof ruleForm>>({
    email: [{ validator: validate_email_optional, trigger: "blur" }],
    password: [{ validator: validate_password, trigger: "blur" }],
    captcha: [{ validator: vidate_captcha, trigger: "blur" }],
    setype: [{ type: "array", validator: validate_type, trigger: "change" }],
    type: [{ validator: validate_fbtype, trigger: "change" }],
    message: [{ validator: validate_message, trigger: "blur" }],
    phone: [{ validator: validate_phone_optional, trigger: "blur" }],
});

//登录注册专用校验规则 (邮箱必填)
const loginRules = reactive<FormRules<typeof ruleForm>>({
    email: [{ validator: validate_email, trigger: "blur" }],
    password: [{ validator: validate_password, trigger: "blur" }],
    captcha: [{ validator: vidate_captcha, trigger: "blur" }],
    setype: [{ type: "array", validator: validate_type, trigger: "change" }],
});

// 触发登录
const uselogin = (formEl: FormInstance | undefined) => {

    logEventAnalytics('c_login', {
        type: 1,
    });

    console.log("点击登录");
    if (!formEl) return;
    formEl.validate(async (valid) => {
        console.log(valid);
        if (valid) {
            useloading.value = true;
            console.log("成功", valid);
            try {
                let res = await use_logoin({
                    username: ruleForm.value.email,
                    password: ruleForm.value.password,
                });
                console.log(res);
                if (res.status == 1) {
                    console.log("登录成功");
                    usefromdata.value = res.data;
                    localStorage.setItem("usetoken", res.token);
                    useloading.value = false;
                    ElMessage.success({
                        message: res.msg,
                        type: "sucess",
                    });
                    useloginblen.value = true;
                    user_handoff("1");
                } else {
                    useloading.value = false;
                    ElMessage.error({
                        message: res.msg,
                        type: "error",
                    });
                }
            } catch (error) {
                throw error
            }
        } else {
            useloading.value = false;
            console.log("失败", valid);
        }
    });
};
// 邮箱格式验证函数
const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};

// 电话格式验证函数
const isValidPhone = (phone: string): boolean => {
    // 支持国际电话格式：+国家码-区号-号码，或纯数字，或带括号、空格、横线的格式
    const phoneRegex = /^[\+]?[1-9][\d]{0,15}$|^[\+]?[(]?[\d\s\-\(\)]{7,20}$/;
    // 移除所有非数字字符后检查长度
    const digitsOnly = phone.replace(/\D/g, '');
    return phoneRegex.test(phone) && digitsOnly.length >= 7 && digitsOnly.length <= 15;
};
//获取邮箱验证码
const get_email_code = async (em: any) => {
    console.log('获取邮箱验证码-register');
    logEventAnalytics("c_email_code", {
        type: em == 'register' ? '1' : '2',
    })
    // 1. 检查邮箱是否为空
    if (!ruleForm.value.email) {
        ElMessage.error({
            message: t('pladdemail'),
            type: 'error',
        });
        return;
    }

    // 2. 验证邮箱格式
    if (!isValidEmail(ruleForm.value.email)) {
        ElMessage.error({
            message: t('emailformat'),
            type: 'error',
        });
        return;
    }

    // 3. 检查是否在倒计时中
    if (remainingTime.value > 0) {
        ElMessage.warning({
            message: t('emailwait').replace('{time}', remainingTime.value),
            type: 'warning',
        });
        return;
    }
    sendtime(60);
    console.log({ email: ruleForm.value.email, event: em });

    try {
        // 4. 发送验证码请求
        let res = await get_ems({ email: ruleForm.value.email, event: em });
        if (res.status == 1) {
            console.log(res);
            ElMessage.success({
                message: res.msg || t('emailsuccess'),
                type: 'success',
            });
            // 5. 开始倒计时

        } else {
            ElMessage.error({
                message: res.msg || t('emailfailed'),
                type: 'error',
            });
        }
    } catch (error) {
        console.error('发送验证码失败:', error);
        ElMessage.error({
            message: t('networkerror'),
            type: 'error',
        });
        throw error;
    }
};
// 发送文本国际化
const btntext = computed(() => t("Send"));
//倒计时
const timetext = ref<any>("");
const remainingTime = ref<any>(0);
// 倒计时定时器ID
let countdownTimer: any = null;

const sendtime = (seconds: any) => {
    timetext.value = `${seconds}s`;
    remainingTime.value = seconds;

    // 清除之前的定时器
    if (countdownTimer) {
        clearInterval(countdownTimer);
    }

    countdownTimer = setInterval(() => {
        if (remainingTime.value <= 0) {
            clearInterval(countdownTimer);
            countdownTimer = null;
            console.log("倒计时结束");
        } else {
            console.log(`剩余时间： ${remainingTime.value}秒`);
            timetext.value = `${remainingTime.value}s`;
            remainingTime.value--;
        }
    }, 1000);
};

// 重置邮箱验证码倒计时
const resetEmailCountdown = () => {
    console.log('重置邮箱验证码倒计时');

    // 清除定时器
    if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
    }

    // 重置状态
    remainingTime.value = 0;
    timetext.value = '';
};
// 点击注册// qE@12345 067281
const usefromdata = ref<any>({});
const register = async (formEl: FormInstance | undefined) => {
    logEventAnalytics("c_register", {
    })
    if (!formEl) return;
    console.log(formEl);
    formEl.validate(async (valid) => {
        if (valid && ruleForm.value.setype.length > 0) {
            useloading.value = true;
            console.log("注册验证成功", valid);
            try {
                let res = await useRegister({
                    username: ruleForm.value.email,
                    password: ruleForm.value.password,
                    captcha: ruleForm.value.captcha,
                });
                if (res.status == 1) {
                    console.log("注册成功");
                    console.log(res);
                    usefromdata.value = res.data;
                    useloading.value = false;
                    useloginblen.value = true;
                    localStorage.setItem("usetoken", res.token);
                    ElMessage.sucess({
                        message: res.msg,
                        type: "sucess",
                    });
                    user_handoff("1");
                } else {
                    console.log(res);
                    useloading.value = false;
                    ElMessage.error({
                        message: res.msg,
                        type: "error",
                    });
                }
            } catch (error) {
                throw error
            }
        } else {
            console.log("注册验证失败", valid);
        }
    });
};
const retap = debounce(
    (formEl: FormInstance | undefined) => {
        register(formEl);
    },
    500,
    false
);
// 注销账号 Del Accout use_deAccount
// 弹窗页面 控制
const dialogblen = ref<any>(false);
const dialogblencancel = () => {
    dialogblen.value = !dialogblen.value;
};
const del_account_de = debounce(
    () => {
        del_account();
    },
    400,
    false
);
const del_account = async () => {


    try {
        let res = await use_deAccount();
        if (res.status == 1) {
            console.log(res, "注销成功");
            ElMessage.success({
                message: res.msg,
                type: "success",
            });
            localStorage.removeItem("usetoken");
            usefromdata.value = {};
            dialogblen.value = false;
            useloginblen.value = false;
            user_handoff("2");
        } else {
            ElMessage.error({
                message: res.msg,
                type: "error",
            });
        }
    } catch (error) {
        throw error
    }

};

//退出登录
const uselogout = async () => {
    logEventAnalytics("c_user_menu", {

        type: "1",
        btnid: "3",

    })
    useloading.value = true;
    try {
        let res = await use_logout({});
        if (res.status == 1) {
            console.log("退出成功");
            useloading.value = false;
            ElMessage.success({
                message: res.msg,
                type: "sucss",
            });
        } else {

        }
    } catch (error) {
        throw error
    }


    // localStorage.clear();
    localStorage.removeItem("usetoken");
    usefromdata.value = {};
    user_handoff("2");
    useloginblen.value = false;
};
/**
 *   我的钱包
 */
const gotowallet = () => {

    logEventAnalytics("c_user_menu", {
        type: "1",
        btnid: "2",
    })

}


//注销账号
const zhuxiao = () => {

    logEventAnalytics("c_user_menu", {
        type: "1",
        btnid: "4",

    })
    dialogblen.value = true
}
const uselogout_de = debounce(
    () => {
        uselogout();
    },
    500,
    false
);
/////////////////////////////////
//忘记密码 修改密码
const forget_password = async (formEl: FormInstance | undefined) => {
    logEventAnalytics("c_forgot_pwd", {
        platform: ""
    })


    if (!formEl) return;
    console.log(formEl);
    formEl.validate(async (valid) => {
        if (valid) {
            useloading.value = true;
            console.log("更改验证成功", valid);

            try {
                let res = await use_resetpwd({
                    email: ruleForm.value.email,
                    password: ruleForm.value.password,
                    captcha: ruleForm.value.captcha,
                });
                console.log(res);
                if (res.status == 1) {
                    useloading.value = false;
                    console.log("更改成功");
                    ElMessage.success({
                        message: res.msg,
                        type: "sucess",
                    });
                    console.log(res);
                    localStorage.removeItem("usetoken");
                    usefromdata.value = {};
                    user_handoff("2");
                } else {
                    useloading.value = false;
                    ElMessage.error({
                        message: res.msg,
                        type: "error",
                    });
                }
            } catch (error) {
                throw error
            }

        } else {
            console.log("更改验证失败", valid);
        }



    });
};
const forget_password_de = debounce(
    (formEl: FormInstance | undefined) => {
        forget_password(formEl);
    },
    500,
    false
);
//////////////////////////////////////////////////////
//获取好友信息
const get_use_friend = async () => {
    try {
        let res = await use_friend({});
        console.log(res);
        if (res.status == 1) {
            console.log("获取成功好友信息成功", res);
            friendsarr.value = res.data;
        }
    } catch (error) {
        throw error
    }

};
//获取收到信息列表
const get_use_received = async () => {
    try {
        let res = await use_received({});
        if (res.status == 1) {
            console.log("获取成功收到信息列表", res);
            friendsarr.value = res.data;
        }
    } catch (error) {
        throw error
    }

};
// 获取请求发送列表 use_sent
const get_use_sent = async () => {
    try {
        let res = await use_sent({});
        if (res.status == 1) {
            console.log("获取成功发送信息列表", res);
            friendsarr.value = res.data;
        }
    } catch (error) {
        throw error
    }
};
// 子传父 触发好友列表事件
const handleAdd = (item: any) => {
    console.log(item);
    // get_use_received()
};
// 子传父 关闭抽屉
const dechouti = (item: any) => {
    console.log(item);
    // getValue()
};
//模糊搜索 friend_search
const search = async (value: string) => {
    // if (textall.value !== '') {
    console.log(textall.value, "文本");
    logEventAnalytics("c_search", {
        type: "2",
        keyword: textall.value,
    })
    try {
        let res = await use_friend({ nickname: textall.value });
        if (res.status == 1) {
            console.log("获取成功", res);
            if (res.data.length > 0) {
                friendsarr.value = res.data;
            } else {
                ElMessage.error(res.msg);
            }
        }
    } catch (error) {
        throw error
    }

};
const friend_search = debounce(
    (value: string) => {
        search(value);
    },
    300,
    false
);
//////////////////////
// 获取用户收藏列表
// 是否展示选择
const showtap = ref<any>(false);
// 当前否选中
const checkedblen = ref<any>(false);
// 收藏列表
const Favoritesarr = ref<any>("");
const get_use_collect = async () => {
    try {
        let res = await use_favorite({});
        if (res.status == 1) {
            Favoritesarr.value = res.data;
            console.log(Favoritesarr.value, "收藏列表");
        }
    } catch (error) {
        throw error
    }
};
// 模糊搜索收藏列表
const collect_de = debounce(
    (timesrtr) => {
        collect_search(timesrtr);
    },
    300,
    false
);
const collect_search = async (value: string) => {
    logEventAnalytics("c_search", {
        type: '3',
        keyword: textall.value,
    })
    console.log(value, '搜索时间')
    let obj: Object
    value ? obj = { keyword: textall.value, startTime: value[0], endTime: value[1] } : obj = { keyword: textall.value }
    try {
        let res = await use_favorite(obj);
        if (res.status == 1) {
            Favoritesarr.value = res.data;
            console.log(Favoritesarr.value, "搜索收藏列表");
        }
    } catch (error) {
        throw error
    }
};
// 开启收藏列表管理
const start_manage = () => {
    logEventAnalytics("c_user_menu", {
        type: "3",
        btnid: "1",
    })

    showtap.value = !showtap.value;
    if (!showtap.value) {
        console.log("取消收藏列表管理,清空");
        checkedblen.value = false;
        Fidarr.value = [];
    }
};
//收集选择游戏id
const Fidarr = ref<any>([]);
const selecttap = (item: any) => {
    console.log(item, "选择的游戏");
    if (item.sblen) {
        Fidarr.value.push(item.gid);
        console.log(Fidarr.value, "已经收集id");
    } else {
        Fidarr.value = Fidarr.value.filter((item1: any) => {
            return item1 != item.gid;
        });
        console.log(Fidarr.value, "已经取消收集id");
    }
};
const delFavorite_de = debounce(
    () => {
        Fidarr.value.length > 0 ? delFavorite() : ElMessage.error(t("plselefg"));
    },
    300,
    false
);
// 删除游戏收藏
const delFavorite = async () => {

    logEventAnalytics("c_user_menu", {
        type: "3",
        btnid: "2",
    })
    console.log("删除收藏", Fidarr.value, "");
    try {
        let res = await use_delFavorite({ gid: Fidarr.value });
        if (res.status == 1) {
            NewpageData.setgid(Fidarr.value);
            console.log(res, "删除成功");
            ElMessage.success(res.msg);
            get_use_collect();
        } else {
            ElMessage.success(res.msg);
        }
    } catch (error) {
        throw error
    }

    Fidarr.value = [];
};
// 获取最近游玩记录
const recodearr = ref<any>([]);
const use_recode_de = debounce(
    (tiemstr) => {

        get_use_recode(tiemstr);
    },
    300,
    false
);
const get_use_recode = async (value: string) => {

    console.log(value, '游玩记录查询')
    let obj: Object
    value ? obj = { keyword: textall.value, startTime: value[0], endTime: value[1] } : obj = { keyword: textall.value }

    try {
        let res = await use_recode(obj);
        if (res.status == 1) {
            console.log(res, "获取成功");
            recodearr.value = res.data;
            // ElMessage.success(res.msg)
        } else {
            ElMessage.success(res.msg);
        }
    } catch (error) {
        throw error;
    }
};
//游戏页面触发反馈
const fbgameblen = ref<any>();
const gamename = ref<any>([]);
const Feedbackon = (item: any) => {
    let { blen, name, id } = item;
    console.log(item, "游戏反馈触发");
    drawer3.value = true;
    fbgameblen.value = blen;
    ruleForm_fb.value.game_id = id;
    gamename.value = name;
};
const Gdloginon = () => {
    drawer2.value = true;
    openindex.value = "3";
};
// 触发反馈
const Feedbackon_de = debounce(
    (formEl: FormInstance | undefined) => {
        feedbacktap(formEl);
    },
    300,
    false
);
const feedbacktap = (formEl: any) => {
    console.log(ruleForm_fb.value);
    if (!formEl) return;
    console.log(formEl);
    formEl.validate(async (valid: any) => {
        if (valid) {
            logEventAnalytics("e_feedback", {
                gid: ruleForm_fb.value.game_id ? ruleForm_fb.value.game_id : '',
                type: ruleForm_fb.value.game_id ? '2' : '1',
                text: ruleForm_fb.value.message,
            })

            console.log("反馈验证成功", valid, {
                ...ruleForm_fb.value,
                plateform: fbgameblen.value ? 1 : 2,
            });
            try {
                let res = await get_feedback({
                    ...ruleForm_fb.value,
                    plateform: fbgameblen.value ? 1 : 2,
                });
                if (res.status == 1) {
                    console.log(res, "反馈成功");
                    ruleFormR_Fb.value?.resetFields();

                    drawer3.value = false;
                    ElMessage.success({
                        message: res.msg,
                        type: "sucess",
                    });
                } else {
                    console.log(res, "反馈失败");
                    ElMessage.error({
                        message: res.msg,
                        type: "error",
                    });
                }
            } catch (error) {
                throw error
            }
        } else {
            console.log("反馈验证失败", valid);
        }
    });
};
//触发合作反馈
const businesstap_de = debounce(
    (formEl: FormInstance | undefined) => {
        businesstap(formEl);
    },
    300,
    false
);
const businesstap = (formEl: any) => {
    console.log(ruleForm_bn.value);
    if (!formEl) return;
    console.log(formEl);
    formEl.validate(async (valid) => {
        if (valid) {
            console.log("反馈验证成功", valid);

            try {
                let res = await get_business({
                    ...ruleForm_bn.value,
                });
                if (res.status == 1) {
                    console.log(res, "反馈成功");
                    ruleFormR_bn.value?.resetFields();
                    drawer4.value = false;
                    ElMessage.success({
                        message: res.msg,
                        type: "sucess",
                    });
                } else {
                    console.log(res, "反馈失败");
                    ElMessage.error({
                        message: res.msg,
                        type: "error",
                    });
                }
            } catch (error) {
                throw error
            }

        } else {
            console.log("反馈验证失败", valid);
        }
    });
};
// 获取全部反馈列表
const feedbackarr = ref<any>([]);
const get_feedbackty = async () => {
    // let res = await get_feedbackType({plateform:2});
    let newarr: any = [];
    try {
        newarr = await Promise.all([
            get_feedbackType({ plateform: 2 }),
            get_feedbackType({ plateform: 1 }),
        ]);
        console.log(newarr, "获取全部反馈列表成功");
        newarr.forEach((item: any, index: any) => {
            if (item.status == 1) {
                feedbackarr.value.push(item.data);
            } else {
                console.log("反馈失败");
            }
        });
        console.log(feedbackarr.value);
    } catch (error) {
        console.error("报错", error);
        throw error;
    }
    // if (res.status == 1) {
    //   console.log(res, "获取反馈列表成功");
    //   feedbackarr.value = res.data;
    //   // ElMessage.success(res.msg)
    // } else {
    //   ElMessage.error(res.msg);
    // }
};
// let newarr: any = [];
//   try {
//     newarr = await Promise.all([
//       use_friend({}),
//       use_received({}),
//       use_sent({}),
//     ]);
//     let [data1, data2, data3] = newarr;
//     console.log(data1, data2, data3, "获取成功");
//     // friendsarr friendgetarr friendsetarr
//     friendsarr.value = data1.data;
//     friendgetarr.value = data2.data;
//     friendsetarr.value = data3.data;
//   } catch (error) {
//     console.error("报错", error);
//   }
get_feedbackty();

const perationTypearr = ref<any>([]);

const get_perationType = async () => {
    try {
        let res = await get_cooperationType({});
        if (res.status == 1) {
            console.log(res, "合作获取成功");
            perationTypearr.value = res.data;
            // ElMessage.success(res.msg)
        } else {
            ElMessage.error(res.msg);
        }
    } catch (error) {
        throw error
    }


};
get_perationType();
///////////////////////////////////////
</script>
<style lang="less" scoped>
.mian {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #191e43 0%, #42213e 50%, #171a28 100%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;

    ::v-deep(.el-checkbox__inner:after) {
        bottom: 0;
        top: 0;
        right: 0;
        left: 0;
        margin: auto;
        width: 4px;
        height: 8px;
    }

    ::v-deep(.el-dialog__body) {
        width: 100% !important;
        height: 100% !important;
        // background: wheat;
    }

    .conetbox {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 40px;
            height: 40px;
            margin-top: 20px;
        }

        p {
            color: white;
            font-size: 16px;
            font-weight: 600;
            margin-top: 20px;
        }

        .btnbox {
            width: auto;
            height: auto;
            margin-top: 30px;
            display: flex;
            justify-content: center;

            .btn {
                transition-duration: 0.2s;
            }

            .btn:hover {
                opacity: 0.7;
            }

            .btn:active {
                transform: scale(0.95);
            }

            .left_btn {
                width: 100px;
                height: 30px;
                border-radius: 10px;
                border: 1px solid #00ffe0;
                text-align: center;
                line-height: 30px;
                color: rgba(0, 255, 224, 1);
                font-size: 16px;
                margin-right: 20px;
            }

            .right_btn {
                width: 100px;
                height: 30px;
                border-radius: 10px;
                background: #00ffe0;
                text-align: center;
                line-height: 30px;
                color: rgba(50, 63, 116, 1);
                font-size: 20px;
            }
        }
    }

    ::v-deep(.el-dialog) {
        width: 300px !important;
        height: 200px !important;
        background: linear-gradient(180deg,
                #1a2734 0%,
                rgba(75, 80, 230, 1) 100%) !important;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        // margin: 0;
        box-sizing: border-box;
    }

    ::v-deep(.el-drawer__header) {
        display: none !important;
    }

    ::v-deep(.el-drawer__body) {
        margin: 0 !important;
        padding: 0 0px !important;
        // padding-left: 16px !important;
        // padding-right: 16px !important;
    }

    ::v-deep(.el-drawer.rtl) {
        width: 100vw !important;
        height: 100%;
        background: linear-gradient(180deg,
                #1a2734 0%,
                rgba(75, 80, 230) 100%) !important;
    }

    @media (orientation: landscape),
    (min-width:600px) {
        ::v-deep(.el-drawer.rtl) {
            width: 375px !important;
        }
    }

    ::v-deep(.el-loading-mask) {
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 10px;
    }

    ::v-deep(.el-loading-spinner) {
        --el-color-primary: rgba(0, 255, 224, 1) !important;
    }

    header {
        width: 100%;
        height: 56px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0px 16px;
        flex-flow: wrap;
        box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);

        .header_leftbox {
            width: 103px;
            height: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header_LOGO {
                width: 100px;
                height: 100%;
                font-size: 18px;
                font-weight: bold;
                color: white;
                flex-shrink: 0;
                margin-right: 20px;
            }

            .header_Searchicon {
                width: 28px;
                height: 28px;
                flex-shrink: 0;
            }
        }

        .header_rightbox {
            width: 150px;
            display: flex;
            justify-content: space-between;

            .header_icon {
                width: 25px;
                height: 25px;
                flex-shrink: 0;
            }
        }
    }

    .Search_masker {
        position: absolute;
        transition-duration: 0.3s;
        z-index: 100;
        top: 0;
        // transform: translateX(v-bind('showSearch'));
        left: v-bind('showSearch');

        width: 100%;
        height: 100%;
        background: rgba(9, 15, 50, 0.5);
        backdrop-filter: blur(30px);
        box-sizing: border-box;
        padding-left: 16px;
        padding-right: 16px;
        display: flex;
        flex-direction: column;

        .Search_top {
            width: 100%;
            height: 42px;
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
            margin-bottom: 20px;

            .Search_top_left {
                flex: 1;
                height: 42px;
                background: #0B1447;
                box-sizing: border-box;
                border: 1px solid #5142fc;
                border-radius: 50px;
                display: flex;
                overflow: hidden;

                .Search_btn {
                    background: #5142fc;
                    width: 41px;
                    height: 41px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 19px;
                        height: 19px;
                    }
                }

                .Search_input {
                    flex: 1;
                    height: 100%;

                }

                input {
                    border: none;
                    height: 26px;
                    margin-left: 10px;
                    background: none;
                    outline: none;
                    outline: 0;
                    font-size: 16px;
                    color: #00ffe0;
                    font-weight: normal;
                }

                input::placeholder {
                    color: white;
                }
            }

            .Search_top_rghit {
                width: 42px;
                height: 42px;
                background: #0B1447;
                border-radius: 50%;
                margin-left: 11px;
                display: flex;
                justify-content: center;
                align-items: center;

                .back_icon {
                    width: 19px;
                    height: 19px;
                }
            }
        }

        .Search_masker_mian {
            width: 100%;
            flex: 1;
            overflow-y: scroll;

            .classifyone {
                width: 100%;
                min-height: 116px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                gap: 10px;
                border-bottom: 1px solid rgba(216, 216, 216, 0.3);
                // background: white;


                .topbox {
                    width: 100%;
                    // background: wheat;
                    height: auto;
                    display: flex;
                    // justify-content:
                    gap: 10px;
                }

                .bottombox {
                    width: 100%;
                    // height: auto;
                    display: flex;
                    // flex-wrap: wrap;
                    // justify-content:
                    gap: 10px;
                    // background: wheat;
                }

                .classifyone_item {
                    width: 268px;
                    // flex: 1;
                    height: 48px;
                    border-radius: 10px;
                    box-sizing: border-box;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition-duration: 0.2s;
                    gap: 10px;


                    .classifyone_icon {
                        width: 28px;
                        height: 28px;
                        flex-shrink: 0;
                    }

                    .classifyone_name {
                        width: auto;
                        height: auto;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        // flex-shrink: 0;
                        font-size: 18px;
                        color: white;
                        text-align: center;

                    }

                }

                .classifyone_item:active {
                    transform: scale(0.95);
                }




            }

            .classifytwo {
                width: 100%;
                height: auto;
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                grid-column-gap: 10px;
                grid-row-gap: 24px;
                justify-content: space-between;
                box-sizing: border-box;
                padding-top: 20px;
                padding-bottom: 20px;

                .classifytwo_item {
                    width: 100%;
                    height: 60px;
                    display: flex;
                    flex-direction: column;
                    transition-duration: 0.2s;
                    justify-content: center;
                    align-items: center;

                    .classifytwo_icon {
                        width: 40px;
                        height: 40px;
                    }

                    .bottom_text {
                        width: 100%;
                        text-align: center;
                        height: 20px;
                        line-height: 20px;
                        font-size: 14px;
                        font-weight: 600;
                        color: white;
                        // background: wheat;
                        // text-align: center;
                    }
                }

                .classifytwo_item:active {
                    transform: scale(0.95);
                }

            }

            .Search_list_item {
                width: 100%;
                height: 50px;
                color: #00ffe0;
                display: flex;
                font-size: 12px;
                align-items: center;

                .Search_img {
                    aspect-ratio: 16/9;
                    width: 60px;
                    height: 40px;
                    border-radius: 5px;
                    margin-right: 15px;
                }
            }

            .about_list {
                width: 100%;
                height: auto;
                color: white;
                font-size: 12px;
                display: grid;

                grid-template-columns: repeat(2, 1fr);
                grid-gap: 8px;
                justify-content: center;

                .about_list_item {
                    width: 100%;
                    height: 20px;
                    text-align: center;
                }
            }

            .right_list_thirdparty {
                width: 100%;
                height: auto;
                // display: v-bind('displayblock');
                box-sizing: border-box;
                margin: auto;

                .icon_box {
                    width: 100%;
                    height: 100px;
                    // background: wheat;
                    margin-top: 40px;
                    display: flex;
                    gap: 10px;
                    justify-content: center;

                    box-sizing: border-box;
                    padding: 5px;

                    .icon_img {
                        width: 40px;
                        height: 40px;
                        overflow: hidden;
                        border-radius: 5px;
                        transition-duration: 0.3s;
                    }

                    .icon_img:hover {
                        transform: scale(1.2);
                    }
                }
            }
        }

    }

    .Content_area {
        width: 100%;
        box-sizing: border-box;
        // scroll-behavior: auto;
        flex: 1;
        overflow-y: scroll;
    }

    .drawer_conent {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0px 16px !important;

        .Friends_conent {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;

            .friends_box {
                width: 100%;
                flex: 1;
                overflow-y: scroll;
                display: flex;
                flex-direction: column;
                overflow-x: hidden;

                // background: wheat;
                .friends_list {
                    width: 100%;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;

                    .top {
                        width: 100%;
                        height: 60px;
                        display: flex;
                        align-items: center;

                        .friends_search {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            position: relative;
                            width: 100%;
                            height: 40px;
                            border-radius: 18px;
                            opacity: 1;
                            box-sizing: border-box;
                            border: 1px solid #5142fc;

                            // margin-bottom: 74px;
                            input {
                                border: none;
                                flex: 1;
                                height: 100%;
                                margin-left: 36px;
                                background: none;
                                outline: none;
                                outline: 0;
                                font-size: 14px;
                                color: #00ffe0;
                                font-weight: normal;
                            }

                            input::placeholder {
                                color: white;
                                font-weight: 16px;
                            }

                            .sreach_icon {
                                margin-right: 20px;
                                margin-left: 20px;
                                width: 35px;
                                height: 35px;
                                // background: wheat;
                                border-radius: 50%;
                                display: flex;
                                justify-content: center;
                                align-items: center;

                                img {
                                    width: 22px;
                                    height: 22px;
                                }
                            }

                            .sreach_icon:hover {
                                background: linear-gradient(180deg,
                                        #1a2734 0%,
                                        rgba(75, 80, 230, 0.3) 100%);
                            }
                        }
                    }

                    .friends_list_item {
                        width: 100%;
                        flex: 1;
                        overflow-y: scroll;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding-bottom: 30px;

                        img {
                            height: 200px;
                            aspect-ratio: 16/9;
                        }

                        .bottomtext_text {
                            width: 100%;
                            min-height: 26px;
                            margin: auto;
                            text-align: center;
                            margin-top: 18px;
                            margin-bottom: 30px;
                            font-size: 26px;
                            font-weight: 600;
                            color: white;
                        }
                    }

                    .friends_not {
                        width: 100%;
                        height: 100%;

                        .kongbai {
                            width: 100%;
                            height: 270px;
                            opacity: 1;
                            margin: auto;

                            img {
                                width: 100%;
                                height: 270px;
                            }
                        }

                        .kongbai_text {
                            width: 249px;
                            min-height: 26px;
                            margin: auto;
                            text-align: center;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            font-size: 18px;
                            font-weight: 600;
                            color: white;
                        }

                        .bottomtext_text {
                            width: 100%;
                            min-height: 26px;
                            margin: auto;
                            color: #ffffff;
                            line-height: 30px;
                            font-weight: 400;
                            font-size: 16px;
                            text-align: center;
                        }
                    }
                }

                .Friend_requests {
                    width: 100%;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;

                    // background: wheat;
                    .Friend_requests_title {
                        width: 100%;
                        height: 40px;
                        font-size: 18px;
                        color: rgba(3, 237, 213, 1);
                        display: flex;
                        align-items: center;
                    }

                    .friends_list_item {
                        width: 100%;
                        flex: 1;
                        overflow-y: scroll;
                        display: flex;
                        flex-direction: column;

                        align-items: center;

                        img {

                            height: 200px;
                            aspect-ratio: 16/9;
                        }

                        .bottomtext_text {
                            width: 249px;
                            min-height: 26px;
                            margin: auto;
                            text-align: center;
                            margin-top: 18px;
                            margin-bottom: 30px;
                            font-size: 26px;
                            font-weight: 600;
                            color: white;
                        }
                    }
                }

                .Friend_application {
                    width: 100%;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;

                    .Friend_application_title {
                        width: 100%;
                        height: 40px;
                        font-size: 18px;
                        color: rgba(3, 237, 213, 1);
                        display: flex;
                        align-items: center;
                    }

                    .friends_list_item {
                        width: 100%;
                        flex: 1;
                        overflow-y: scroll;
                        display: flex;
                        flex-direction: column;

                        align-items: center;

                        img {
                            height: 200px;
                            aspect-ratio: 16/9;
                        }

                        .bottomtext_text {
                            width: 249px;
                            min-height: 26px;
                            margin: auto;
                            text-align: center;
                            margin-top: 18px;
                            margin-bottom: 30px;
                            font-size: 26px;
                            font-weight: 600;
                            color: white;
                        }
                    }
                }

                .Friend_Mine {
                    width: 100%;
                    min-height: 548px;
                    // margin-top: 50px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;

                    .Friend_Mine_title {
                        width: 100%;
                        height: 78px;
                        font-size: 14px;
                        color: white;
                        // text-justify: distribute;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-content: space-around;
                        margin-top: 20px;
                        margin-bottom: 30px;
                        text-align: center;
                    }

                    .Friend_qr {
                        width: 160px;
                        height: 160px;
                        border-radius: 5px;
                        overflow: hidden;
                        margin-bottom: 37px;
                        aspect-ratio: 1/1;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    // Share your profile
                    .Friend_Share {
                        box-sizing: border-box;
                        width: 285px;
                        height: 42px;
                        border-radius: 10px;
                        background: linear-gradient(180deg,
                                #ffffff 0%,
                                rgba(255, 255, 255, 0) 100%),
                            #00ffe0;
                        background-blend-mode: overlay, normal;
                        margin-bottom: 36px;
                        font-size: 16px;
                        color: #323f74;

                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        transition-duration: 0.2s;

                        .Share_icon {
                            width: 20px;
                            height: 20px;
                            // margin-right: 56px;
                            position: absolute;
                            left: 35px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                    .Friend_Share:active {
                        transform: scale(0.95);
                    }

                    .Friend_Copy {
                        box-sizing: border-box;
                        width: 285px;
                        height: 42px;
                        border-radius: 10px;
                        transition-duration: 0.2s;
                        border: 1.28px solid #00ffe0;
                        margin-bottom: 56px;
                        font-size: 16px;
                        color: #ffffff;

                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;

                        .Share_icon {
                            width: 20px;
                            height: 20px;
                            // margin-right: 56px;
                            position: absolute;
                            left: 35px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                    .Friend_Copy:active {
                        transform: scale(0.95);
                    }
                }

                .loginnull {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .imgon {
                        width: 379px;
                        height: 270px;
                        // margin-top: 120px;
                    }

                    .kongbai_text {
                        min-width: 249px;
                        min-height: 26px;
                        margin: auto;
                        text-align: center;
                        margin-top: 18px;
                        margin-bottom: 40px;
                        font-size: 26px;
                        font-weight: 600;
                        color: white;
                    }

                    .bottomtext_text {
                        width: 636px;
                        min-height: 26px;
                        color: #ffffff;
                        line-height: 30px;
                        font-weight: 400;
                        font-size: 20px;
                        text-align: center;
                    }

                    .gologinbtn {
                        width: 100%;
                        height: 40px;
                        background: #00ffe0;
                        box-shadow: 0px 2px 21px 0px rgba(0, 0, 0, 0.2),
                            0px 8px 10px 0px rgba(0, 0, 0, 0.12),
                            0px 4px 8px 0px rgba(0, 0, 0, 0.14);
                        border-radius: 10px;
                        font-weight: 600;
                        font-size: 18px;
                        text-align: center;
                        line-height: 40px;
                        margin-top: 50px;
                        transition-duration: 0.2s;
                    }

                    .gologinbtn:hover {
                        opacity: 0.7;
                    }

                    .gologinbtn:active {
                        transform: scale(0.95);
                    }
                }
            }

            .friends_list_Options {
                width: 100%;
                height: 60px;
                border-radius: 0px 30px 0px 0px;
                position: absolute;
                bottom: 0;
                left: 0;
                backdrop-filter: blur(6px);
                // background: red;
                display: flex;
                align-items: center;
                justify-content: space-around;
                // margin-top: 147px;
                margin: auto;

                .Options_tab {
                    min-width: 80px;
                    height: 42px;
                    border-radius: 8px;
                    color: #ffffff;
                    font-weight: bold;
                    font-size: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid transparent;
                    transition-duration: 0.2s;
                    box-sizing: border-box;
                    padding: 10px;
                }

                // .Options_tab:hover {
                //     opacity: 0.5;
                // }

                .selected_tab {
                    border: 1px solid #00ffe0;
                    color: #00ffe0;
                }
            }
        }

        .Favorites_conent {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;

            .Favorites_top {
                width: 100%;
                height: 48px;
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
                align-items: center;

                .Favorites_search {
                    height: 42px;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    // position: relative;

                    border-radius: 24px;
                    opacity: 1;
                    box-sizing: border-box;
                    border: 1px solid #5142fc;

                    // margin-bottom: 93px;
                    input {
                        border: none;
                        width: 100%;
                        height: 26px;
                        margin-left: 30px;
                        background: none;
                        outline: none;
                        outline: 0;
                        font-size: 16px;
                        color: #00ffe0;
                        font-weight: normal;
                    }

                    input::placeholder {
                        color: white;
                        // font-weight: 400;
                    }

                    .sreach_icon {
                        margin-right: 20px;
                        width: 35px;
                        height: 35px;
                        flex-shrink: 0;
                        // background: wheat;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 50%;

                        img {
                            width: 22px;
                            height: 22px;
                        }
                    }

                    .sreach_icon:hover {
                        background: linear-gradient(180deg,
                                #1a2734 0%,
                                rgba(75, 80, 230, 0.3) 100%);
                    }
                }


            }

            // Favorites_top
            .timeselect {
                width: 320px;
                height: 50px;


                ::v-deep(.el-date-editor.el-input__wrapper) {
                    height: 46px !important;
                    width: 320px !important;
                    background-color: transparent !important;
                    border-radius: 24px !important;
                    border: 1px solid #5142fc !important;
                    box-shadow: none !important;

                }

                ::v-deep(.el-date-editor .el-range-input) {
                    color: rgba(255, 255, 255, 0.6) !important;
                    font-size: 16px !important;
                    height: 30px !important;
                }

                ::v-deep(.el-date-editor .el-range-separator) {
                    color: rgba(255, 255, 255, 0.6) !important;
                }
            }

            .Favorites_box {
                width: 100%;
                flex: 1;
                box-sizing: border-box;
                padding-bottom: 80px;
                overflow-y: scroll;

                .friends_list_item {
                    width: 100%;
                    height: 100%;
                    flex: 1;
                    overflow-y: scroll;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    img {

                        // height: 100px;
                        height: 200px;
                        aspect-ratio: 16/9;
                    }

                    .bottomtext_text {
                        width: 249px;
                        min-height: 26px;
                        margin: auto;
                        text-align: center;
                        margin-top: 18px;
                        margin-bottom: 30px;
                        font-size: 26px;
                        font-weight: 600;
                        color: white;
                    }
                }

                .Favorites_list_item {
                    width: 100%;
                    height: auto;
                    border-radius: 10px;
                    background: #00204F;
                    box-sizing: border-box;
                    padding: 8px;
                    margin-bottom: 20px;

                    .Favorites_list_title {
                        width: 100%;
                        height: 20px;
                        font-size: 16px;
                        color: #00ffe0;
                        font-weight: bold;
                    }

                    .Favorites_cardconent {
                        width: auto;
                        height: auto;
                        margin: 18px auto 0px;
                        display: grid;
                        flex-wrap: wrap;
                        grid-template-columns: repeat(2, 1fr);
                        grid-gap: 8px;
                        justify-content: space-between;
                        // background: white;

                        .Favorites_card {
                            // width: 100%;
                            // height: 87px;
                            aspect-ratio: 157/87;
                            border-radius: 5px;
                            flex-shrink: 0;
                            // margin-bottom: 20px;
                            overflow: hidden;
                        }
                    }
                }
            }

            .Favorites_right {
                width: 100%;
                left: 0;
                height: 78px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                bottom: 0;
                background: linear-gradient(180deg, rgba(0, 61, 79, 0) 21%, #003D4F 48%);
                backdrop-filter: blur(10px);
                padding: 0px 16px !important;
                box-sizing: border-box;
                border-top-right-radius: 15px;
                border-top-left-radius: 15px;

                .Favorites_btn {
                    width: 167px;
                    height: 34px;
                    border-radius: 24px;
                    box-sizing: border-box;
                    font-size: 14px;
                    font-weight: 350;
                    color: white;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    transition: all 0.3s ease;

                    // padding:10px;
                }

                // .Favorites_btn:hover {
                //     opacity: 0.8;
                // }

                .Favorites_btn:active {
                    transform: scale(0.9);
                }

                .Favorites_img {
                    width: 22px;
                    height: 22px;
                    // margin-right: 25px;
                }

                .Favorites_Delete {
                    border: 1px solid #ffffff;
                    translate: 50% 0px;
                    opacity: 0.3;
                }

                .Favorites_Manage {
                    background: linear-gradient(239deg, #e250e5 9%, #4b50e6 89%);
                    border: 1px solid #5142fc;
                    translate: -50% 0px;
                    font-size: 16px !important;
                    box-sizing: border-box;
                }

                .tranbtn {
                    translate: 0px 0px;
                }

                .tranbtnone {
                    translate: -10px 0px;
                    opacity: 1;
                }
            }



        }

        .User_Center {
            width: 100%;
            height: 100%;

            ::v-deep(.el-input__wrapper) {
                margin: 0 !important;
                padding: 0 !important;
                background: transparent;
                width: 285px;
                height: 38px;
                box-sizing: border-box;
                // border: 1.28px solid #00ffe0;
                border-radius: 10px;
                box-shadow: 0 0 0 1px #00ffe0 inset;
                padding-left: 20px !important;
                padding-right: 20px !important;
                font-size: 12px;
                color: red;

                .el-input__inner {
                    color: white !important;
                }

                // --el-input-text-color: white !important;
                // .el-form-item__error {
                //     font-size: 12px !important;
                // }
            }

            ::v-deep(.el-form-item__error) {
                // top: calc(100% + 20px);
                font-size: 12px;
                top: 113%;
            }


            .user_one {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                overflow-y: scroll;
                position: relative;
                box-sizing: border-box;


                .User_title {
                    width: 100%;
                    height: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 20px;

                    .User_title_left {
                        width: 230px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        overflow-x: scroll;

                        input {
                            background: transparent;
                            border: none;
                            box-shadow: none;
                            color: white;
                            font-size: 18px;
                            width: 20px;
                            margin: 0;
                            padding: 0;
                        }

                        .User_icon {
                            width: 48px;
                            height: 48px;
                            border-radius: 50%;
                            background: white;
                            // margin-right: 16px;
                            overflow: hidden;
                            display: flex;
                            position: relative;

                            .icon {
                                width: 48px;
                                height: 48px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 20px;
                            }

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            .iconmask {
                                position: absolute;
                                background: rgba(32, 43, 68, 0.5);
                                top: 0;
                                width: 48px;
                                height: 48px;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                img {
                                    width: 15px;
                                    height: 15px;
                                }

                                img:hover {
                                    opacity: 0.7;
                                }
                            }
                        }

                        .User_right {
                            width: 180px;
                            height: 50px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .User_name {
                                width: 100%;
                                font-size: 16px;
                                font-weight: bold;
                                color: white;
                                display: flex;
                                height: auto;
                                align-items: center;
                                height: 26px;
                                visibility: visible;

                                .Chagebox {
                                    width: 100%;
                                    border-radius: 20px;
                                    background: #313d70;
                                    height: 26px;
                                    border: 1px solid #00fcdd;
                                    display: flex;
                                    align-items: center;
                                    box-sizing: border-box;

                                    input {
                                        width: 100%;
                                        font-size: 16px;
                                        font-weight: bold;
                                        box-sizing: border-box;
                                        color: white;
                                        flex: 1;
                                        // padding: 0;
                                        box-shadow: none !important;
                                        outline: none;
                                        padding-left: 10px;
                                        padding-right: 10px;
                                    }

                                    input::placeholder {
                                        color: white;
                                    }

                                    .usecompletebox {
                                        width: 50px;
                                        height: 25px;
                                        border-radius: 20px;
                                        opacity: 1;
                                        background: #00fedf;
                                        font-size: 14px;
                                        text-align: center;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        color: #323f74;
                                        font-weight: bold;
                                        box-sizing: border-box;
                                        padding: 10px;
                                    }
                                }

                                .Chageboxone {
                                    width: 116px;
                                    box-sizing: border-box;
                                    padding-left: 10px;
                                    padding-top: 1px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    flex-wrap: nowrap;
                                    height: 26px;
                                    border: 1px solid transparent;
                                }

                                img {
                                    width: 20px;
                                    height: 20px;
                                    margin-left: 20px;
                                }
                            }

                            .User_eamil {
                                width: 100%;
                                font-size: 14px;
                                color: #a1a1a1;
                                box-sizing: border-box;
                                padding-left: 11px;
                            }
                        }
                    }

                    .User_title_right {
                        width: 100px;
                        height: 32px;
                        border-radius: 24px;
                        background: linear-gradient(239deg, #e250e5 9%, #4b50e6 89%);
                        box-sizing: border-box;
                        border: 1px solid #5142fc;
                        color: white;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                .User_Information {
                    width: 100%;
                    height: 30px;
                    // background: wheat;
                    display: flex;
                    margin-top: 35px;
                    margin-bottom: 20px;
                    align-items: center;
                    justify-content: space-around;

                    .User_Information_item {
                        height: 100%;
                        min-width: 80px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        // align-content: space-around;
                        // margin-right: 87px;
                        align-items: center;

                        .text_one {
                            min-width: 21px;
                            height: 17px;
                            text-align: center;
                            line-height: 17px;
                            font-size: 14px;
                            color: #ffffff;
                            text-align: center;
                            margin-bottom: 10px;
                            font-weight: bold;
                        }

                        .text_two {
                            min-width: 57px;
                            height: 17px;
                            font-size: 14px;
                            color: #ffffff;
                            text-align: center;
                            font-weight: bold;
                        }
                    }
                }

                .User_outing_history {
                    width: 100%;
                    flex: 1;
                    box-sizing: border-box;
                    padding-bottom: 80px;
                    // background: wheat;
                    overflow-y: scroll;

                    .User_outing_card {
                        width: 100%;
                        height: auto;

                        margin-top: 30px;
                        background: #00204F;
                        border-radius: 10px;
                        box-sizing: border-box;
                        padding: 10px;

                        .User_outing_card_title {
                            width: 100%;
                            height: 17px;
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 20px;

                            .title_left {
                                min-width: 212px;
                                font-size: 18px;
                                color: #00ffe0;
                                box-sizing: border-box;
                                font-weight: bold;
                            }

                            .title_right {
                                width: 97px;
                                height: 17px;
                                font-size: 14px;
                                color: #00ffe0;
                                text-align: right;
                                line-height: 17px;
                            }
                        }

                        .User_outing_list_not {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;

                            img {
                                width: 90%;
                                height: 90%;
                            }

                            .bottomtext {
                                margin-top: 32px;
                                width: 100%;
                                font-weight: 600;
                                font-size: 26px;
                                text-align: center;
                                margin-top: 20px;
                                color: white;
                            }
                        }

                        .User_outing_list {
                            width: 100%;
                            min-height: 254px;
                            display: grid;
                            flex-wrap: wrap;
                            grid-template-columns: repeat(2, 157px);
                            grid-gap: 7px;
                            justify-content: space-between;

                            .User_outing_list_item {
                                width: 157px;
                                height: 87px;
                                border-radius: 5px;
                                overflow: hidden;
                                // background: wheat;
                                flex-shrink: 0;
                            }
                        }
                    }
                }

                .User_bottom_btn {
                    width: 100%;
                    height: 78px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    // position: absolute;
                    position: fixed;
                    left: 0;
                    bottom: 0;

                    background: linear-gradient(180deg, rgba(0, 61, 79, 0) 21%, #003D4F 48%);
                    backdrop-filter: blur(10px);
                    padding: 0px 16px !important;
                    box-sizing: border-box;
                    border-top-right-radius: 15px;
                    border-top-left-radius: 15px;

                    .dle_btn {
                        border: 1px solid #ffffff;
                        // margin-right: 16px;
                    }

                    .login_out {
                        background: linear-gradient(239deg, #e250e5 9%, #4b50e6 89%);
                        border: 1px solid #5142fc;
                    }

                    .btn {
                        min-width: 138px;
                        height: 32px;
                        border-radius: 24px;
                        color: white;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 16px;
                        transition-duration: 0.2s;
                    }

                    .btn:hover {
                        opacity: 0.5;
                    }

                    .btn:active {
                        transform: scale(0.95);
                    }
                }
            }

            .user_login {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                overflow-y: scroll;

                box-sizing: border-box;

                .user_login_title {
                    width: 328px;
                    height: 26px;
                    font-size: 18px;
                    color: white;
                    // margin: auto;
                    margin-top: 43px;
                    text-align: center;
                    margin-bottom: 42px;
                    font-weight: bold;
                }

                .user_login_googlebtn {
                    position: relative;
                    width: 100%;
                    // min-width: 343px;
                    height: 57px;
                    // background: linear-gradient(180deg,
                    //     #ffffff 0%,
                    //     rgba(255, 255, 255, 0) 100%),
                    //   #00ffe0;
                    background-blend-mode: overlay, normal;
                    border-radius: 10px;
                    font-size: 20px;
                    color: #323f74;
                    box-sizing: border-box;

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-weight: 500;
                    margin-bottom: 18px;

                    // overflow: hidden;
                    // .googlebtn {
                    //     position: absolute;
                    //     top: 0px;
                    //     width: 100%;
                    //     height: 100%;
                    //     height: 57px;
                    //     display: flex;
                    //     justify-content: center;
                    //     align-items: center;

                    //     .googlebtn_icon {
                    //         width: 25px;
                    //         height: 25px;
                    //         margin-right: 34px;
                    //     }
                    // }
                }

                .user_login_googlebtn:hover {
                    // opacity: 0.6;
                }

                .user_login_googlebtn:active {
                    // transform: scale(0.95);
                }

                .third_party {
                    width: 232px;
                    height: 32px;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 61px;

                    .third_party_icon {
                        width: 32px;
                        height: 32px;
                    }
                }

                .Accout_login_title {
                    width: 207px;
                    height: 20px;
                    font-size: 18px;
                    color: white;
                    text-align: center;
                    margin-bottom: 25px;
                    font-weight: bold;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .leftone {
                        width: 50px;
                        height: 1px;
                        background: white;
                        margin-right: 3px;
                    }

                    .rightone {
                        width: 50px;
                        height: 1px;
                        background: white;
                        margin-left: 3px;
                    }
                }

                // .Accout_login {
                //     width: 474px;
                //     min-height: 206px;

                .Accout_login_Form {
                    width: 285px;
                    min-height: 206px;

                    // background: wheat;

                    .Accout_login_icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 17px;
                    }

                    .Accout_login_item1 {
                        width: 100%;
                        height: 38px;

                        // padding-top: 16px;
                        // padding-bottom: 16px;

                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        margin-bottom: 20px;
                        position: relative;

                        .validatetext {
                            position: absolute;
                            width: 80%;
                            height: 20px;
                            // background: wheat;
                            bottom: -20px;
                            color: red;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                        }
                    }

                    .Accout_login_item2 {
                        width: 100%;
                        height: 38px;

                        border-radius: 16px;

                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        margin-bottom: 20px;
                        position: relative;

                        .validatetext {
                            position: absolute;
                            width: 80%;
                            height: 20px;
                            // background: wheat;
                            bottom: -20px;
                            color: red;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                        }
                    }

                    .Accout_operation {
                        width: 100%;
                        height: 26px;
                        display: flex;
                        justify-content: space-between;
                        font-size: 12px;
                        color: #ffffff;
                        margin-bottom: 121px;

                        // text-align: center;
                        text {
                            color: #00ffe0;
                        }

                        .rigt_box {
                            color: #00ffe0;
                            height: 26px;
                            line-height: 26px;
                        }

                        .left_box {
                            height: 26px;
                            line-height: 26px;
                        }
                    }

                    .Accout_loginbtn {
                        width: 285px;
                        height: 42px;
                        border-radius: 18px;
                        opacity: 1;
                        background: linear-gradient(180deg, #E250E5 0%, #4B50E6 100%);
                        box-sizing: border-box;
                        border: 1px solid #5142fc;
                        margin: auto;
                        font-size: 18px;
                        font-weight: bold;
                        color: #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }

            .user_register {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                overflow-y: scroll;

                box-sizing: border-box;

                .user_register_Form {
                    width: 100%;
                    min-height: 206px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    // background: wheat;

                    .user_register_icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 18px;
                    }

                    .user_register_item1 {
                        width: 285px;
                        height: 38px;
                        // border: 1px solid #00ffe0;
                        border-radius: 16px;
                        // padding-top: 20px;
                        // padding-bottom: 20px;
                        // padding-right: 36px;
                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        margin-bottom: 20px;

                        .user_register_send {
                            width: 30px;
                            height: 100%;
                            font-size: 12px;
                            color: #c6c6c6;
                            border-left: 1px solid #00ffe0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            transition-duration: 0.2s;
                            box-sizing: border-box;
                            padding-left: 20px;
                        }

                        .user_register_send:hover {
                            opacity: 0.5;
                        }

                        .user_register_send:active {
                            transform: scale(0.95);
                        }
                    }

                    .user_register_item2 {
                        width: 285px;
                        height: 38px;

                        border-radius: 16px;

                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        margin-bottom: 20px;
                    }

                    .user_register_operation {
                        width: 285px;

                        height: 26px;
                        display: flex;
                        justify-content: space-between;
                        font-size: 14px;
                        color: #ffffff;
                        margin-bottom: 29px;
                        box-sizing: border-box;
                        padding-top: 25px;

                        text {
                            color: #00ffe0;
                        }

                        .rigt_box {
                            color: #00ffe0;
                            height: 26px;
                            line-height: 26px;
                        }

                        .left_box {
                            height: 26px;
                            line-height: 26px;
                        }
                    }

                    .user_register_check {
                        width: 285px;

                        min-height: 36px;
                        display: flex;
                        // align-items: center;

                        .textbox {
                            flex: 1;
                            min-height: 36px;
                            font-size: 13px;
                            color: white;
                            // line-height: 25px;

                            // 确保 a 标签样式生效，包括动态插入的内容
                            a,
                            ::v-deep(a) {
                                color: #00ffe0 !important;
                                text-decoration: none !important;
                                font-weight: 500 !important;

                                &:hover {
                                    color: #00d4c4 !important;
                                    text-decoration: underline !important;
                                }

                                &:visited {
                                    color: #00ffe0 !important;
                                }

                                &:active {
                                    color: #00b8aa !important;
                                }

                                &:focus {
                                    color: #00ffe0 !important;
                                    outline: none !important;
                                }
                            }
                        }

                        ::v-deep(.el-checkbox) {
                            width: 22px;
                            height: 22px;
                            margin-right: 17px;
                            margin-top: 8px;

                            .el-checkbox__input {
                                width: 100%;
                                height: 100%;

                                .el-checkbox__original {
                                    width: 22px !important;
                                    height: 22px !important;
                                }

                                .el-checkbox__inner {
                                    width: 22px !important;
                                    height: 22px !important;
                                    background-color: transparent !important;
                                    border-color: #4b50e6;
                                }
                            }
                        }

                        margin-bottom: 82px;
                    }

                    .user_register_loginbtn {
                        width: 285px;
                        height: 42px;
                        border-radius: 18px;
                        opacity: 1;
                        background: linear-gradient(180deg, #E250E5 0%, #4B50E6 100%);
                        border-radius: 10px;
                        box-sizing: border-box;
                        border: 1px solid #5142fc;
                        margin: auto;
                        font-size: 18px;
                        color: #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }

        .Records_conent {
            width: 100%;
            height: 100%;
            box-sizing: border-box;

            display: flex;
            flex-direction: column;
            overflow-y: scroll;

            // align-items: center;
            .Records_top {
                display: flex;
                height: 48px;
                align-items: center;

                .Records_search {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    // width: 100%;
                    height: 35px;
                    border-radius: 24px;
                    opacity: 1;
                    box-sizing: border-box;
                    border: 1px solid #5142fc;
                    // margin-right: 30px;

                    // margin-bottom: 93px;
                    input {
                        border: none;
                        flex: 1;
                        flex-shrink: 0;
                        height: 26px;
                        margin-left: 52px;
                        background: none;
                        outline: none;
                        outline: 0;
                        font-size: 14px;
                        color: #00ffe0;
                        font-weight: normal;
                    }

                    input::placeholder {
                        color: white;
                        // font-weight: 400;
                    }

                    .sreach_icon {
                        margin-right: 30px;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;

                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            width: 22px;
                            height: 22px;
                        }
                    }

                    .sreach_icon:hover {
                        background: linear-gradient(180deg,
                                #1a2734 0%,
                                rgba(75, 80, 230, 0.3) 100%);
                    }
                }

                .timeselect {
                    width: 320px;
                    height: 50px;


                    ::v-deep(.el-date-editor.el-input__wrapper) {
                        height: 46px !important;
                        width: 320px !important;
                        background-color: transparent !important;
                        border-radius: 24px !important;
                        border: 1px solid #5142fc !important;
                        box-shadow: none !important;

                    }

                    ::v-deep(.el-date-editor .el-range-input) {
                        color: rgba(255, 255, 255, 0.6) !important;
                        font-size: 16px !important;
                        height: 30px !important;
                    }

                    ::v-deep(.el-date-editor .el-range-separator) {
                        color: rgba(255, 255, 255, 0.6) !important;
                    }
                }

            }

            .Records_box {
                width: 100%;
                flex: 1;
                overflow-y: scroll;
                // margin-top: 14.5px;
                padding-top: 20px;

                .friends_list_item {
                    width: 100%;
                    height: 100%;
                    flex: 1;
                    overflow-y: scroll;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;


                    img {
                        height: 200px;
                        aspect-ratio: 16/9;
                    }

                    .bottomtext_text {
                        width: 249px;
                        min-height: 26px;
                        margin: auto;
                        text-align: center;
                        margin-top: 18px;
                        margin-bottom: 30px;
                        font-size: 26px;
                        font-weight: 600;
                        color: white;
                    }
                }

                .Favorites_list_item {
                    width: 100%;
                    height: auto;
                    background: rgba(0, 0, 0, 0.5);
                    margin-bottom: 10px;
                    padding: 8px;
                    border-radius: 10px;
                    box-sizing: border-box;

                    .Favorites_list_title {
                        width: 100%;
                        height: 20px;
                        font-size: 16px;
                        color: #00ffe0;
                        margin-bottom: 10px;
                        margin-top: 10px;
                        // font-weight: bold;
                    }

                    .Favorites_cardconent {
                        width: 100%;
                        height: auto;
                        display: grid;
                        flex-wrap: wrap;
                        grid-template-columns: repeat(2, 1fr);
                        grid-gap: 7px;
                        justify-content: space-between;

                        .Favorites_card {
                            // width: 100%;
                            // height: 87px;
                            aspect-ratio: 157/87;
                            border-radius: 5px;
                            flex-shrink: 0;
                            // margin-bottom: 20px;
                            overflow: hidden;
                        }
                    }
                }
            }
        }

        .Feedback_conent {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;

            ::v-deep(.el-input__wrapper) {
                background: transparent;
            }

            ::v-deep(.el-form-item__error) {
                // top: calc(100% + 20px);
                font-size: 12px;
                top: 110%;
            }

            .Feedback_box {
                width: 100%;
                flex: 1;
                overflow-y: scroll;

                ::v-deep(.el-select__placeholder) {
                    color: #cacaca !important;
                }

                .Feedback_item {
                    width: 100%;
                    height: auto;
                    margin-bottom: 20px;

                    .Feedback_title {
                        width: 100%;
                        height: 20px;
                        font-size: 16px;
                        color: #00ffe0;
                        margin-bottom: 10px;
                    }

                    .Feedback_input {
                        width: 100%;
                        height: 42px;
                        background: #323f74;
                        box-sizing: border-box;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;


                        ::v-deep(.el-select__wrapper) {
                            width: 100% !important;
                            padding-right: 10px !important;
                            line-height: none !important;
                            background: none;
                            box-shadow: none;
                        }

                        // [data-v-720cb8b3]
                        ::v-deep(.el-form-item) {
                            width: 100%;
                            height: 100%;
                            margin-bottom: 0px !important;
                        }

                        ::v-deep(.el-input__inner) {
                            font-size: 14px !important;
                            color: white !important;
                        }

                        ::v-deep(.el-input__wrapper) {
                            box-shadow: none !important;
                            padding: 0 !important;
                        }

                        ::v-deep(.el-form-item__content) {

                            padding-left: 18px;
                            padding-right: 18px;
                        }
                    }

                    .Feedback_textarea {
                        width: 100%;
                        height: 244px;
                        background: #323f74;
                        color: white;
                        border-radius: 15px;

                        ::v-deep(.el-textarea__inner) {
                            color: #cacaca;
                            padding: 10px !important;
                            box-sizing: border-box;
                            background: none !important;
                            box-shadow: none;
                            height: 244px !important;
                            max-height: 266px !important;
                        }

                        .texts {
                            height: 100% !important;
                            color: white;
                        }
                    }
                }

                .Feedback_btn {
                    // display: flex;
                    color: #323f74;
                    font-size: 16px;
                    font-weight: 900;
                    margin: auto;
                    width: 343px;
                    height: 42px;
                    background: #00ffe0;
                    border-radius: 15px;
                    position: relative;
                    bottom: 20px;
                    transition-duration: 0.2s;

                    line-height: 42px;
                    text-align: center;
                    margin-top: 40px;
                }

                .Feedback_btn:active {
                    transform: scale(0.95);
                }

                .Feedback_btn:hover {
                    opacity: 0.7;
                }
            }
        }
    }

    .i18nchange {
        width: 100%;
        height: 39px;
        // background: red;
        // margin-left: 20px;
        margin-top: 30px;
        margin-bottom: 30px;
        overflow: hidden;

        box-sizing: border-box;
        border: 1px solid #5142fc;
        border-radius: 20px;
        display: v-bind("displayblock");

        ::v-deep(.el-select) {
            width: 100%;
            color: white;

            .el-select__wrapper {
                width: 100% !important;
                height: 39px !important;
                background: transparent !important;
                line-height: none !important;
                box-shadow: none !important;
            }
        }

        ::v-deep(.el-select__placeholder) {
            color: white !important;
            font-size: 14px !important;
            text-align: center;
            line-height: 36px;
            background: transparent !important;
        }

        ::v-deep(.el-icon) {
            height: 17px !important;
        }
    }

    .backtopbox {
        width: 50px;
        height: 50px;
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: rgba(251, 109, 58, 0.5);
        backdrop-filter: blur(10px);
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        display: flex;
        z-index: 20;
        transition-duration: 0.5s;
        animation: btnback 0.5s;
        opacity: v-bind('opacityctrl');

        .icon_box {
            width: 20px;
            height: 20px;
            // background: #FB6D3A;
            border-radius: 50%;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    // @keyframes btnback {
    //     from{
    //         opacity: 0.5;
    //     }
    //     to{
    //         opacity: 1;
    //     }

    // }

}
</style>
<style lang="less">
//下拉框的背景色
.el-select-dropdown__item {
    background: transparent !important;
}

//下拉框的链接小方块
.el-select-dropdown__item.is-active {
    // background: #2A77C6 !important;
}

//鼠标移动上去的选中色
.el-select-dropdown__item.hover,
//下拉框背景色
.el-popper.is-light.mySelectStyle {
    width: auto;
    height: auto;
    background: #323f74 !important;
    // background: red !important;
    border: 1px solid #323f74 !important;
}

//下拉框的链接小方块
.mySelectStyle.el-popper[data-popper-placement^="bottom"] .el-popper__arrow::before {
    background: #323f74 !important;
    border: 1px solid #323f74 !important;
    // display: none;
    translate: round(0deg);
}

.mySelectStyle.el-popper[data-popper-placement^="top"] .el-popper__arrow::before {
    background: #254277 !important;
    // red
    //  background: red !important;
    // border: 1px solid #254277 !important;
}

//鼠标移动上去的选中色
.mySelectStyle {
    position: relative;

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
        background: rgba(230, 230, 250, 0.2) !important;
    }


    //下拉框的文本颜色
    .el-select-dropdown__item {
        height: 35px !important;
        color: white !important;
        font-family: Archivo Narrow !important;
        font-size: 14px;
        padding: 0 32px 0 20px !important;
    }

    //选中之后的颜色
    .el-select-dropdown__item.selected {
        background: rgba(11, 101, 135, 1) !important;
    }
}

// .date-style {

//     border: 1px solid #0B1447 !important;
//     border-radius: 25px !important;
//     background: #0B1447 !important;
//     overflow: hidden;

//     .el-picker-panel {
//         background: none !important;
//     }

//     .el-input--small .el-input__inner {
//         background: #0B1447 !important;
//     }

//     .el-input__wrapper {
//         background: #0B1447 !important;
//     }

//     .el-date-table td.start-date .el-date-table-cell__text {
//         background: #0B1447 !important;
//     }

//     .el-date-table td.end-date .el-date-table-cell__text {
//         background: #0B1447 !important;
//     }

//     .el-picker-panel__footer {
//         background: #0B1447 !important;
//     }

//     .el-date-table td.today .el-date-table-cell__text {
//         color: #3C46C1 !important;
//     }

//     .el-date-editor .el-range-separator {
//         color: #D8D8D8 !important;
//     }

// }</style>
